import { useState, useEffect, useCallback, useRef } from "react";

// ===== COLORS =====
const C = {
  bg:"#06090F",s:"#0D1321",card:"#151D2E",cardH:"#1A2540",b:"#253250",
  p:"#10B981",pd:"#059669",a:"#3B82F6",w:"#F59E0B",d:"#EF4444",
  t:"#F1F5F9",td:"#94A3B8",tm:"#64748B",purple:"#8B5CF6"
};
const inp={width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${C.b}`,background:C.s,color:C.t,fontSize:13,outline:"none",boxSizing:"border-box"};
const lbl={fontSize:11,fontWeight:600,color:C.td,marginBottom:4,display:"block",textTransform:"uppercase",letterSpacing:"0.4px"};
const sbtn={padding:"4px 10px",borderRadius:6,border:`1px solid ${C.b}`,background:C.s,color:C.t,cursor:"pointer",fontSize:12,fontWeight:600};

// ===== INITIAL DATA =====
const INIT_CATS = ["Snacks","Dairy","Spices","Beverages","Bakery","Home","Staples","Cooking"];
const INIT_GST = [{id:1,name:"Standard",rate:17},{id:2,name:"Exempt",rate:0},{id:3,name:"Reduced",rate:5},{id:4,name:"Special",rate:12}];
const INIT_PRODUCTS = [
  {id:1,name:"Dairy Milk Chocolate",barcode:"8901233012345",price:150,cost:110,stock:48,cat:"Snacks",gstId:1,unit:"pc",img:"🍫"},
  {id:2,name:"Nestle Milk Pack 1L",barcode:"8901234567890",price:280,cost:220,stock:120,cat:"Dairy",gstId:1,unit:"pc",img:"🥛"},
  {id:3,name:"Shan Biryani Masala",barcode:"8901235678901",price:95,cost:65,stock:200,cat:"Spices",gstId:1,unit:"pc",img:"🌶️"},
  {id:4,name:"Tapal Danedar 400g",barcode:"8901236789012",price:650,cost:500,stock:85,cat:"Beverages",gstId:1,unit:"pc",img:"🍵"},
  {id:5,name:"Olper's Cream 200ml",barcode:"8901237890123",price:180,cost:140,stock:60,cat:"Dairy",gstId:1,unit:"pc",img:"🧈"},
  {id:6,name:"Dawn Bread Large",barcode:"8901238901234",price:210,cost:170,stock:30,cat:"Bakery",gstId:2,unit:"pc",img:"🍞"},
  {id:7,name:"Pepsi 1.5L",barcode:"8901239012345",price:190,cost:150,stock:150,cat:"Beverages",gstId:1,unit:"pc",img:"🥤"},
  {id:8,name:"Surf Excel 1kg",barcode:"8901241234567",price:450,cost:360,stock:70,cat:"Home",gstId:1,unit:"pc",img:"🧴"},
  {id:9,name:"Sufi Cooking Oil 5L",barcode:"8901243456789",price:2850,cost:2400,stock:40,cat:"Cooking",gstId:1,unit:"pc",img:"🫗"},
  {id:10,name:"Guard Rice 5kg",barcode:"8901244567890",price:1200,cost:950,stock:55,cat:"Staples",gstId:1,unit:"pc",img:"🍚"},
];
const INIT_CUSTOMERS = [
  {id:1,name:"Ahmad Ali",phone:"0321-4567890",email:"ahmad@email.com",address:"DHA Phase 5, Lahore",visits:12,totalSpent:45000},
  {id:2,name:"Fatima Noor",phone:"0333-1234567",email:"fatima@email.com",address:"Gulberg III, Lahore",visits:8,totalSpent:28000},
  {id:3,name:"Usman Ghani",phone:"0300-9876543",email:"",address:"Model Town, Lahore",visits:5,totalSpent:15000},
];
const INIT_DISCOUNTS = [
  {id:1,name:"Summer Sale",type:"category",target:"Beverages",percent:10,startDate:"2026-05-01",endDate:"2026-06-30",active:true},
  {id:2,name:"Ramadan Special",type:"product",targetId:4,target:"Tapal Danedar 400g",percent:15,startDate:"2026-03-01",endDate:"2026-03-30",active:false},
];

// Sales history for analytics
const genSalesHistory = () => {
  const data = [];
  for(let d=30;d>=0;d--){
    const dt=new Date();dt.setDate(dt.getDate()-d);
    data.push({date:dt.toISOString().slice(0,10),day:dt.toLocaleDateString("en",{weekday:"short"}),
      revenue:Math.floor(15000+Math.random()*85000),orders:Math.floor(8+Math.random()*40),
      items:Math.floor(20+Math.random()*120),profit:Math.floor(5000+Math.random()*25000)});
  }
  return data;
};

export default function BillKaroPOS(){
  const [tab,setTab]=useState("pos");
  const [products,setProducts]=useState(INIT_PRODUCTS);
  const [categories,setCategories]=useState(INIT_CATS);
  const [gstRules,setGstRules]=useState(INIT_GST);
  const [customers,setCustomers]=useState(INIT_CUSTOMERS);
  const [discounts,setDiscounts]=useState(INIT_DISCOUNTS);
  const [cart,setCart]=useState([]);
  const [search,setSearch]=useState("");
  const [toast,setToast]=useState("");
  const [time,setTime]=useState(new Date());
  const [salesHistory]=useState(genSalesHistory);
  // Modals
  const [showAddProduct,setShowAddProduct]=useState(false);
  const [showAddCat,setShowAddCat]=useState(false);
  const [showAddGst,setShowAddGst]=useState(false);
  const [showAddCustomer,setShowAddCustomer]=useState(false);
  const [showAddDiscount,setShowAddDiscount]=useState(false);
  const [showBulkImport,setShowBulkImport]=useState(false);
  const [showBarcodeScan,setShowBarcodeScan]=useState(false);
  const [showReceiptSettings,setShowReceiptSettings]=useState(false);
  const [editCust,setEditCust]=useState(null);
  const [showWhatsapp,setShowWhatsapp]=useState(false);
  const [waMsg,setWaMsg]=useState("Dear customer, we have exciting offers this week! Visit us today. — ");
  const [showFbrSetup,setShowFbrSetup]=useState(false);
  const [fbrConfig,setFbrConfig]=useState({posId:"POS-LHR-0001",ntn:"1234567-8",token:"fbr_tk_xxxxxxxxxxxxx",endpoint:"https://gw.fbr.gov.pk/di_data/v1/di/",tokenExpiry:"2031-06-15",autoRetry:true});
  // Employee & Shift
  const [employees]=useState([{id:1,name:"Admin",pin:"1234",role:"owner"},{id:2,name:"Ali Cashier",pin:"1111",role:"cashier"},{id:3,name:"Sara Manager",pin:"2222",role:"manager"}]);
  const [loggedIn,setLoggedIn]=useState(true);
  const [currentUser,setCurrentUser]=useState({name:"Admin",role:"owner"});
  const [loginPin,setLoginPin]=useState("");
  const [shiftOpen,setShiftOpen]=useState(true);
  const [shiftStart]=useState(new Date());
  // Returns
  const [showReturn,setShowReturn]=useState(false);
  const [returnInvId,setReturnInvId]=useState("");
  const [returnItems,setReturnItems]=useState([]);
  const [returnReason,setReturnReason]=useState("defective");
  // Multi-payment
  const [showPayment,setShowPayment]=useState(false);
  const [payMethod,setPayMethod]=useState("cash");
  const [paySplit,setPaySplit]=useState({cash:"",card:"",mobile:""});
  // Stock alerts
  const LOW_STOCK_THRESHOLD=35;
  // Udhar / Credit system
  const [udharLedger,setUdharLedger]=useState([
    {id:1,custId:1,custName:"Ahmad Ali",custPhone:"0321-4567890",date:"2026-05-28",items:[{name:"Sufi Oil 5L",qty:1,price:2850},{name:"Guard Rice 5kg",qty:2,price:1200}],total:5250,paid:0,status:"unpaid"},
    {id:2,custId:2,custName:"Fatima Noor",custPhone:"0333-1234567",date:"2026-05-25",items:[{name:"Tapal Danedar",qty:3,price:650}],total:1950,paid:1000,status:"partial"},
  ]);
  const [isUdhar,setIsUdhar]=useState(false);
  const [udharPayId,setUdharPayId]=useState(null);
  const [udharPayAmt,setUdharPayAmt]=useState("");
  // Multi-branch
  const [branches,setBranches]=useState([{id:1,name:"Main Branch — Lahore",inv:true,fbr:true,udhar:true}]);
  const [activeBranch,setActiveBranch]=useState(1);
  const [multiBranch,setMultiBranch]=useState(false);
  // License
  const [licenseKey,setLicenseKey]=useState("BK-DEMO-2026-FREE");
  const [licenseValid]=useState(true);
  const [editProdId,setEditProdId]=useState(null);
  const [editProdData,setEditProdData]=useState({});
  const [cmdInput,setCmdInput]=useState("");
  // Smart command processor — natural language, no quotes needed
  const processCmd=(cmd)=>{
    const c=cmd.toLowerCase().trim();
    let matched=false;
    // Try to find product name match (longest match first)
    const sortedProds=[...products].sort((a,b)=>b.name.length-a.name.length);
    for(const p of sortedProds){
      const pName=p.name.toLowerCase();
      const words=pName.split(" ");
      const matchesFullName=c.includes(pName);
      const matchesPartial=words.some(w=>w.length>3&&c.includes(w));
      if(matchesFullName||matchesPartial){
        const nums=c.match(/\d+/g);
        if(nums&&nums.length>0){
          const val=+nums[nums.length-1];
          if(c.includes("stock")||c.includes("qty")||c.includes("quantity")||c.includes("packet")||c.includes("piece")||c.includes("unit")){
            if(c.includes("add")||c.includes("plus")||c.includes("increase")||c.includes("received")){
              setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:x.stock+val}:x));
              showT(`✓ ${p.name}: stock +${val} → ${p.stock+val}`);matched=true;break;
            }else if(c.includes("reduce")||c.includes("minus")||c.includes("decrease")||c.includes("remove")||c.includes("damage")){
              setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:Math.max(0,x.stock-val)}:x));
              showT(`✓ ${p.name}: stock -${val} → ${Math.max(0,p.stock-val)}`);matched=true;break;
            }else{
              setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:val}:x));
              showT(`✓ ${p.name}: stock set to ${val}`);matched=true;break;
            }
          }else if(c.includes("price")||c.includes("rs")){
            if(c.includes("cost")){setProducts(pr=>pr.map(x=>x.id===p.id?{...x,cost:val}:x));showT(`✓ ${p.name}: cost → Rs.${val}`)}
            else{setProducts(pr=>pr.map(x=>x.id===p.id?{...x,price:val}:x));showT(`✓ ${p.name}: price → Rs.${val}`)}
            matched=true;break;
          }else{
            // Default: if just a number with product name, assume stock update
            if(c.includes("add")||c.startsWith("add")){
              setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:x.stock+val}:x));
              showT(`✓ ${p.name}: stock +${val} → ${p.stock+val}`);
            }else{
              setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:val}:x));
              showT(`✓ ${p.name}: stock set to ${val}`);
            }
            matched=true;break;
          }
        }
      }
    }
    if(!matched) showT("Could not match product. Try: add 10 surf excel or set pepsi price 200");
    setCmdInput("");
  };
  // Print receipt — shows receipt overlay then triggers print
  const [showPrintPreview,setShowPrintPreview]=useState(false);
  const printReceipt=()=>setShowPrintPreview(true);
  const doPrint=()=>{
    const el=document.getElementById("receipt-print");
    if(!el) return;
    const win=window.open("","","width=350,height=600");
    win.document.write("<html><body>"+el.innerHTML+"<scr"+"ipt>window.print();window.close()</"+"script></body></html>");
    win.document.close();
  };
  // Delete product
  const deleteProd=(id)=>{if(window.confirm("Delete this product?"))setProducts(p=>p.filter(x=>x.id!==id))};
  const [cmdText,setCmdText]=useState("");
  // POS state
  const [selectedCustomer,setSelectedCustomer]=useState(null);
  const [customerSearch,setCustSearch]=useState("");
  const [sendToFbr,setSendToFbr]=useState(true);
  const [manualDiscount,setManualDiscount]=useState(0);
  const [analyticsPeriod,setAnalyticsPeriod]=useState("week");
  // New item forms
  const [newProd,setNewProd]=useState({name:"",barcode:"",price:"",cost:"",stock:"",cat:"Snacks",gstId:1,img:"📦",imageUrl:""});
  const [newCat,setNewCat]=useState("");
  const [newGst,setNewGst]=useState({name:"",rate:""});
  const [newCust,setNewCust]=useState({name:"",phone:"",email:"",address:""});
  const [newDisc,setNewDisc]=useState({name:"",type:"product",targetId:"",percent:"",startDate:"",endDate:""});
  const [bulkCsv,setBulkCsv]=useState("");
  const [barcodeInput,setBarcodeInput]=useState("");
  const barcodeRef=useRef(null);
  // Receipt settings
  const [receipt,setReceipt]=useState({
    businessName:"My Store",phone:"0300-1234567",email:"info@mystore.pk",
    address:"Main Boulevard, Lahore",tagline:"Thank you for shopping!",
    logoText:"MY STORE",logoType:"text",logoImage:"",showLogo:true,showPhone:true,showEmail:true,showAddress:true,showFbrQr:true
  });
  // FBR logs
  const [fbrLogs,setFbrLogs]=useState([
    {id:"INV-001",time:"10:32 AM",total:1850,status:"synced",irn:"FBR-20260531103218",customer:"Walk-in",sentToFbr:true},
    {id:"INV-002",time:"10:45 AM",total:960,status:"synced",irn:"FBR-20260531104509",customer:"Ahmad Ali",sentToFbr:true},
    {id:"INV-003",time:"11:02 AM",total:4200,status:"pending",irn:"—",customer:"Walk-in",sentToFbr:true},
    {id:"INV-004",time:"11:18 AM",total:470,status:"skipped",irn:"N/A",customer:"Fatima Noor",sentToFbr:false},
  ]);

  useEffect(()=>{const t=setInterval(()=>setTime(new Date()),1000);return()=>clearInterval(t)},[]);
  const showT=useCallback(m=>{setToast(m);setTimeout(()=>setToast(""),3000)},[]);

  // Get GST rate for product
  const getGst=(p)=>(gstRules.find(g=>g.id===p.gstId)||{rate:0}).rate;
  // Get active discount for product
  const getDiscount=(p)=>{
    const today=new Date().toISOString().slice(0,10);
    const pd=discounts.find(d=>d.active&&d.type==="product"&&d.targetId===p.id&&d.startDate<=today&&d.endDate>=today);
    if(pd) return pd.percent;
    const cd=discounts.find(d=>d.active&&d.type==="category"&&d.target===p.cat&&d.startDate<=today&&d.endDate>=today);
    return cd?cd.percent:0;
  };

  const addToCart=(p)=>setCart(prev=>{
    const ex=prev.find(i=>i.id===p.id);
    return ex?prev.map(i=>i.id===p.id?{...i,qty:i.qty+1}:i):[...prev,{...p,qty:1}];
  });

  // Cart calculations
  const cartLines=cart.map(i=>{
    const gstRate=getGst(i);
    const discPct=getDiscount(i);
    const lineTotal=i.price*i.qty;
    const discAmt=Math.round(lineTotal*discPct/100);
    const afterDisc=lineTotal-discAmt;
    const tax=Math.round(afterDisc*gstRate/100);
    return{...i,gstRate,discPct,discAmt,afterDisc,tax,lineGrand:afterDisc+tax};
  });
  const subtotal=cartLines.reduce((s,l)=>s+l.afterDisc,0);
  const totalTax=cartLines.reduce((s,l)=>s+l.tax,0);
  const totalDisc=cartLines.reduce((s,l)=>s+l.discAmt,0);
  const extraDisc=Math.round(subtotal*manualDiscount/100);
  const grandTotal=subtotal+totalTax-extraDisc;

  const handleCheckout=()=>{
    if(cart.length===0) return;
    const invId=`INV-${String(fbrLogs.length+1).padStart(3,"0")}`;
    const t2=time.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"});
    setFbrLogs(prev=>[{id:invId,time:t2,total:grandTotal,status:sendToFbr?"synced":"skipped",irn:sendToFbr?`FBR-${Date.now()}`:"N/A",customer:selectedCustomer?.name||"Walk-in",sentToFbr:sendToFbr},...prev]);
    setProducts(prev=>prev.map(p=>{const ci=cart.find(c=>c.id===p.id);return ci?{...p,stock:p.stock-ci.qty}:p;}));
    if(selectedCustomer){
      setCustomers(prev=>prev.map(c=>c.id===selectedCustomer.id?{...c,visits:c.visits+1,totalSpent:c.totalSpent+grandTotal}:c));
    }
    showT(`✓ ${invId} — Rs.${grandTotal.toLocaleString()} ${sendToFbr?"synced to FBR":"(FBR skipped)"}`);
    setCart([]);setSelectedCustomer(null);setManualDiscount(0);
  };

  // Add product
  const handleAddProd=()=>{
    if(!newProd.name||!newProd.price) return showT("Name and price required");
    setProducts(p=>[...p,{...newProd,id:Date.now(),price:+newProd.price,cost:+newProd.cost||0,stock:+newProd.stock||0,gstId:+newProd.gstId,unit:"pc",barcode:newProd.barcode||`BK${Date.now()}`,imageUrl:newProd.imageUrl||""}]);
    setNewProd({name:"",barcode:"",price:"",cost:"",stock:"",cat:categories[0]||"General",gstId:1,img:"📦",imageUrl:""});
    setShowAddProduct(false);showT("✓ Product added");
  };
  // Add category
  const handleAddCat=()=>{
    if(!newCat||categories.includes(newCat)) return showT("Enter a unique category name");
    setCategories(p=>[...p,newCat]);setNewCat("");setShowAddCat(false);showT(`✓ Category "${newCat}" added`);
  };
  // Add GST rule
  const handleAddGst=()=>{
    if(!newGst.name||newGst.rate==="") return showT("Name and rate required");
    setGstRules(p=>[...p,{id:Date.now(),name:newGst.name,rate:+newGst.rate}]);
    setNewGst({name:"",rate:""});setShowAddGst(false);showT("✓ GST rule added");
  };
  // Add customer
  const handleAddCust=()=>{
    if(!newCust.name||!newCust.phone) return showT("Name and phone required");
    const c={...newCust,id:Date.now(),visits:0,totalSpent:0};
    setCustomers(p=>[...p,c]);setNewCust({name:"",phone:"",email:"",address:""});
    setShowAddCustomer(false);setSelectedCustomer(c);showT(`✓ Customer "${c.name}" added`);
  };
  // Add discount
  const handleAddDisc=()=>{
    if(!newDisc.name||!newDisc.percent||!newDisc.startDate||!newDisc.endDate) return showT("Fill all fields");
    const d={...newDisc,id:Date.now(),percent:+newDisc.percent,active:true,
      target:newDisc.type==="category"?newDisc.targetId:(products.find(p=>p.id===+newDisc.targetId)||{}).name||"",
      targetId:newDisc.type==="product"?+newDisc.targetId:undefined};
    setDiscounts(p=>[...p,d]);setNewDisc({name:"",type:"product",targetId:"",percent:"",startDate:"",endDate:""});
    setShowAddDiscount(false);showT("✓ Discount created");
  };
  // Bulk import
  const handleBulkImport=()=>{
    try{
      const lines=bulkCsv.trim().split("\n").slice(1);
      const imported=lines.map((l,i)=>{
        const[name,barcode,price,cost,stock,cat,gst]=l.split(",").map(s=>s.trim());
        return{id:Date.now()+i,name,barcode:barcode||`BK${Date.now()+i}`,price:+price||0,cost:+cost||0,stock:+stock||0,cat:cat||"General",gstId:+(gstRules.find(g=>g.rate===+gst)||{id:1}).id,unit:"pc"};
      }).filter(p=>p.name&&p.price>0);
      if(imported.length===0) return showT("No valid products found in CSV");
      setProducts(p=>[...p,...imported]);setShowBulkImport(false);setBulkCsv("");
      showT(`✓ ${imported.length} products imported`);
    }catch(e){showT("CSV format error — check your data");}
  };
  // Barcode scan
  const handleBarcodeScan=()=>{
    const found=products.find(p=>p.barcode===barcodeInput);
    if(found){addToCart(found);showT(`✓ "${found.name}" added to cart`);setBarcodeInput("");
    }else{setNewProd(p=>({...p,barcode:barcodeInput}));setShowBarcodeScan(false);setShowAddProduct(true);showT("Product not found — add it now");}
  };

  const filtered=products.filter(p=>p.name.toLowerCase().includes(search.toLowerCase())||p.barcode.includes(search)||p.cat.toLowerCase().includes(search.toLowerCase()));
  const cleanPhone=(s)=>s.replace(/[^0-9]/g,"");
  const filteredCusts=customers.filter(c=>c.name.toLowerCase().includes(customerSearch.toLowerCase())||cleanPhone(c.phone).includes(cleanPhone(customerSearch))||c.phone.includes(customerSearch));

  // Analytics data
  const getAnalyticsData=()=>{
    if(analyticsPeriod==="day") return salesHistory.slice(-1);
    if(analyticsPeriod==="week") return salesHistory.slice(-7);
    return salesHistory.slice(-30);
  };
  const aData=getAnalyticsData();
  const totalRev=aData.reduce((s,d)=>s+d.revenue,0);
  const totalOrders=aData.reduce((s,d)=>s+d.orders,0);
  const totalItems=aData.reduce((s,d)=>s+d.items,0);
  const totalProfit=aData.reduce((s,d)=>s+d.profit,0);
  const maxRev=Math.max(...aData.map(d=>d.revenue));

  const tabs=[{id:"pos",icon:"🛒",l:"POS"},{id:"products",icon:"📦",l:"Products"},{id:"customers",icon:"👥",l:"Customers"},
    {id:"udhar",icon:"📒",l:"Udhar/Credit"},{id:"discounts",icon:"🏷️",l:"Discounts"},{id:"analytics",icon:"📊",l:"Analytics"},{id:"fbr",icon:"🛡️",l:"FBR"},{id:"settings",icon:"⚙️",l:"Settings"}];

  return(
  <div style={{background:C.bg,minHeight:"100vh",color:C.t,fontFamily:"'Segoe UI',system-ui,sans-serif",fontSize:13}}>
    {toast&&<div style={{position:"fixed",top:12,left:"50%",transform:"translateX(-50%)",zIndex:999,background:C.p,color:"#fff",padding:"8px 20px",borderRadius:8,fontSize:13,fontWeight:600,boxShadow:"0 8px 24px rgba(16,185,129,.3)"}}>{toast}</div>}

    {/* ===== LOGIN SCREEN ===== */}
    {!loggedIn&&(
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:C.bg}}>
        <div style={{background:C.card,borderRadius:16,padding:32,width:320,border:`1px solid ${C.b}`,textAlign:"center"}}>
          <div style={{width:56,height:56,borderRadius:14,background:`linear-gradient(135deg,${C.p},${C.a})`,display:"inline-flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:24,color:"#fff",marginBottom:12}}>B</div>
          <div style={{fontWeight:700,fontSize:20,marginBottom:4}}>Bill<span style={{color:C.p}}>Karo</span></div>
          <div style={{fontSize:11,color:C.tm,marginBottom:20}}>Enter your PIN to start shift</div>
          <input type="password" value={loginPin} onChange={e=>setLoginPin(e.target.value)} onKeyDown={e=>{
            if(e.key==="Enter"){const emp=employees.find(x=>x.pin===loginPin);if(emp){setCurrentUser({name:emp.name,role:emp.role});setLoggedIn(true);setShiftOpen(true);showT(`Welcome ${emp.name}!`)}else{showT("Invalid PIN");setLoginPin("")}}
          }} placeholder="Enter 4-digit PIN" maxLength={4}
            style={{...inp,textAlign:"center",fontSize:24,letterSpacing:12,fontWeight:700,padding:"14px"}}/>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginTop:14}}>
            {[1,2,3,4,5,6,7,8,9,"C",0,"→"].map(k=>(
              <button key={k} onClick={()=>{
                if(k==="C") setLoginPin("");
                else if(k==="→"){const emp=employees.find(x=>x.pin===loginPin);if(emp){setCurrentUser({name:emp.name,role:emp.role});setLoggedIn(true);setShiftOpen(true);showT(`Welcome ${emp.name}!`)}else{showT("Invalid PIN");setLoginPin("")}}
                else if(loginPin.length<4) setLoginPin(p=>p+k);
              }} style={{padding:12,borderRadius:8,border:"none",background:k==="→"?C.p:k==="C"?C.d:C.s,color:"#fff",fontSize:18,fontWeight:700,cursor:"pointer"}}>{k}</button>
            ))}
          </div>
          <div style={{marginTop:16,fontSize:10,color:C.tm}}>Demo PINs: Admin=1234 · Cashier=1111 · Manager=2222</div>
        </div>
      </div>
    )}

    {loggedIn&&<>
    {/* HEADER */}
    <div style={{background:C.s,borderBottom:`1px solid ${C.b}`,padding:"8px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <div style={{width:32,height:32,borderRadius:8,background:`linear-gradient(135deg,${C.p},${C.a})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:14,color:"#fff"}}>B</div>
        <div><div style={{fontWeight:700,fontSize:15}}>Bill<span style={{color:C.p}}>Karo</span></div><div style={{fontSize:9,color:C.tm}}>v2.0 — Full Featured</div></div>
      </div>
      <div style={{display:"flex",gap:12,alignItems:"center",fontSize:11}}>
        {multiBranch&&<select value={activeBranch} onChange={e=>setActiveBranch(+e.target.value)} style={{...inp,width:"auto",padding:"3px 8px",fontSize:10,background:C.s,border:`1px solid ${C.b}`}}>
          {branches.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
        </select>}
        <span style={{color:C.p}}>● Online</span>
        <span style={{color:C.td}}>{time.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"})}</span>
        <span style={{padding:"3px 8px",borderRadius:5,background:"rgba(59,130,246,.15)",color:C.a,fontWeight:600,border:`1px solid rgba(59,130,246,.3)`}}>👤 {currentUser.name} ({currentUser.role})</span>
        <span onClick={()=>{setShiftOpen(!shiftOpen);showT(shiftOpen?"Shift closed":"Shift opened")}} style={{padding:"3px 8px",borderRadius:5,background:shiftOpen?"rgba(16,185,129,.15)":"rgba(239,68,68,.15)",color:shiftOpen?C.p:C.d,fontWeight:600,border:`1px solid ${shiftOpen?"rgba(16,185,129,.3)":"rgba(239,68,68,.3)"}`,cursor:"pointer"}}>{shiftOpen?"🟢 Shift Open":"🔴 Shift Closed"}</span>
        <span style={{padding:"3px 8px",borderRadius:5,background:sendToFbr?"rgba(16,185,129,.15)":"rgba(239,68,68,.15)",color:sendToFbr?C.p:C.d,fontWeight:600,border:`1px solid ${sendToFbr?"rgba(16,185,129,.3)":"rgba(239,68,68,.3)"}`}}>{sendToFbr?"FBR ON":"FBR OFF"}</span>
        <button onClick={()=>{setLoggedIn(false);setLoginPin("");showT("Logged out")}} style={{...sbtn,fontSize:10,padding:"3px 8px",color:C.d,borderColor:"rgba(239,68,68,.3)"}}>Logout</button>
      </div>
    </div>

    {/* TABS */}
    <div style={{display:"flex",gap:1,padding:"4px 16px",background:C.s,borderBottom:`1px solid ${C.b}`,overflowX:"auto"}}>
      {tabs.map(t=>(
        <button key={t.id} onClick={()=>setTab(t.id)} style={{display:"flex",alignItems:"center",gap:4,padding:"7px 12px",borderRadius:6,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,whiteSpace:"nowrap",
          background:tab===t.id?`linear-gradient(135deg,${C.p},${C.pd})`:"transparent",color:tab===t.id?"#fff":C.tm}}>{t.icon} {t.l}</button>
      ))}
    </div>

    {/* ===== GLOBAL: Add/Edit Customer Modal (works from any tab) ===== */}
    {showAddCustomer&&<div style={{padding:"0 16px"}}><Modal title={editCust?"✏️ Edit customer":"👤 Add new customer"} onClose={()=>{setShowAddCustomer(false);setEditCust(null)}}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div><label style={lbl}>Full name *</label><input style={inp} value={newCust.name} onChange={e=>setNewCust(p=>({...p,name:e.target.value}))} placeholder="e.g. Ahmad Ali"/></div>
        <div><label style={lbl}>Phone *</label><input style={inp} value={newCust.phone} onChange={e=>setNewCust(p=>({...p,phone:e.target.value}))} placeholder="0300-1234567"/></div>
        <div><label style={lbl}>Email</label><input style={inp} value={newCust.email} onChange={e=>setNewCust(p=>({...p,email:e.target.value}))} placeholder="email@example.com"/></div>
        <div><label style={lbl}>Address</label><input style={inp} value={newCust.address} onChange={e=>setNewCust(p=>({...p,address:e.target.value}))} placeholder="Street, City"/></div>
      </div>
      <button onClick={()=>{
        if(!newCust.name||!newCust.phone) return showT("Name and phone required");
        if(editCust){
          setCustomers(p=>p.map(c=>c.id===editCust.id?{...c,...newCust}:c));
          if(selectedCustomer?.id===editCust.id) setSelectedCustomer(p=>({...p,...newCust}));
          showT(`✓ "${newCust.name}" updated`);
        }else{
          const c={...newCust,id:Date.now(),visits:0,totalSpent:0};
          setCustomers(p=>[...p,c]);setSelectedCustomer(c);
          showT(`✓ "${c.name}" added`);
        }
        setNewCust({name:"",phone:"",email:"",address:""});setShowAddCustomer(false);setEditCust(null);
      }} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px",marginTop:12}}>{editCust?"Update Customer":"Save Customer"}</button>
    </Modal></div>}

    {/* ===== GLOBAL: WhatsApp Broadcast Modal ===== */}
    {showWhatsapp&&<div style={{padding:"0 16px"}}><Modal title="📲 WhatsApp broadcast" onClose={()=>setShowWhatsapp(false)} wide>
      <div style={{fontSize:12,color:C.td,marginBottom:10}}>Select customers and send a promotional message via WhatsApp. You can send to all at once or pick specific customers.</div>
      <label style={lbl}>Message</label>
      <textarea value={waMsg} onChange={e=>setWaMsg(e.target.value)} style={{...inp,height:80,resize:"vertical"}} placeholder="Type your message here..."/>

      {/* Select customers */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"12px 0 8px"}}>
        <span style={{fontSize:12,color:C.td,fontWeight:600}}>Select recipients ({customers.filter(c=>c._wa).length} of {customers.length} selected)</span>
        <div style={{display:"flex",gap:6}}>
          <button onClick={()=>setCustomers(p=>p.map(c=>({...c,_wa:true})))} style={{...sbtn,fontSize:10,padding:"4px 10px",color:C.p,borderColor:"rgba(16,185,129,.3)"}}>✓ Select all</button>
          <button onClick={()=>setCustomers(p=>p.map(c=>({...c,_wa:false})))} style={{...sbtn,fontSize:10,padding:"4px 10px"}}>✕ Deselect all</button>
        </div>
      </div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
        {customers.filter(c=>c.phone).map(c=>(
          <label key={c.id} onClick={()=>setCustomers(p=>p.map(x=>x.id===c.id?{...x,_wa:!x._wa}:x))}
            style={{...sbtn,padding:"6px 12px",borderRadius:8,cursor:"pointer",display:"flex",alignItems:"center",gap:6,
              background:c._wa?"rgba(37,211,102,.15)":"transparent",
              borderColor:c._wa?"rgba(37,211,102,.4)":C.b,
              color:c._wa?"#25D366":C.td}}>
            <span style={{width:16,height:16,borderRadius:4,border:`2px solid ${c._wa?"#25D366":C.b}`,background:c._wa?"#25D366":"transparent",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"#fff"}}>{c._wa?"✓":""}</span>
            <span style={{fontWeight:600}}>{c.name}</span>
            <span style={{fontSize:10,color:C.tm}}>{c.phone}</span>
          </label>
        ))}
      </div>

      {/* Send buttons */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <button onClick={()=>{
          const selected=customers.filter(c=>c.phone&&c._wa);
          if(selected.length===0) return showT("Select at least one customer");
          let delay=0;
          selected.forEach(c=>{
            const phone=c.phone.replace(/[^0-9]/g,"");
            const waPhone=phone.startsWith("0")?"92"+phone.slice(1):phone;
            setTimeout(()=>{
              window.open(`https://wa.me/${waPhone}?text=${encodeURIComponent(waMsg+receipt.businessName)}`,"_blank");
            },delay);
            delay+=800;
          });
          showT(`✓ Opening WhatsApp for ${selected.length} customers...`);
        }} style={{...sbtn,background:"#25D366",color:"#fff",border:"none",padding:"10px 20px",fontSize:13,borderRadius:8}}>
          📲 Send to {customers.filter(c=>c._wa).length} selected customers
        </button>
        <button onClick={()=>{
          const selected=customers.filter(c=>c.phone&&c._wa);
          if(selected.length===0) return showT("Select at least one customer");
          const numbers=selected.map(c=>{const p=c.phone.replace(/[^0-9]/g,"");return p.startsWith("0")?"92"+p.slice(1):p});
          const text=`Numbers for bulk send:\n${numbers.join("\n")}\n\nMessage:\n${waMsg}${receipt.businessName}`;
          navigator.clipboard?.writeText(text);
          showT(`✓ ${numbers.length} numbers + message copied to clipboard — paste into WhatsApp Business`);
        }} style={{...sbtn,padding:"10px 20px",fontSize:12,borderRadius:8}}>
          📋 Copy numbers + message
        </button>
      </div>
      <div style={{marginTop:10,padding:10,background:C.s,borderRadius:8,fontSize:11,color:C.td,lineHeight:1.6}}>
        <b style={{color:C.w}}>💡 Pro tip:</b> "Send to selected" opens a WhatsApp tab for each customer with your message pre-filled — just hit Send in each tab. For 50+ customers, use "Copy numbers + message" and paste into <b>WhatsApp Business API</b> or a bulk sender tool like <b>WATool</b>, <b>WATI.io</b>, or <b>Twilio</b> for one-click mass delivery.
      </div>
    </Modal></div>}

    {/* ===== GLOBAL: Return/Refund Modal — FIXED OVERLAY ===== */}
    {showReturn&&<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,.7)",zIndex:998,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:C.card,borderRadius:14,border:`1px solid ${C.p}`,padding:24,maxWidth:700,width:"100%",maxHeight:"80vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}>
        <h3 style={{margin:0,fontSize:16,fontWeight:700,color:C.d}}>↩️ Return / Refund / Exchange</h3>
        <button onClick={()=>{setShowReturn(false);setReturnItems([])}} style={{background:"none",border:"none",color:C.tm,cursor:"pointer",fontSize:18}}>✕</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
        <div><label style={lbl}>Invoice number</label><input style={inp} value={returnInvId} onChange={e=>setReturnInvId(e.target.value)} placeholder="e.g. INV-001"/></div>
        <div><label style={lbl}>Reason</label>
          <select style={inp} value={returnReason} onChange={e=>setReturnReason(e.target.value)}>
            <option value="defective">Defective product</option><option value="wrong">Wrong item</option>
            <option value="expired">Expired</option><option value="change_mind">Customer changed mind</option><option value="exchange">Exchange for different item</option>
          </select>
        </div>
      </div>
      <label style={lbl}>Select products to return</label>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
        {products.slice(0,10).map(p=>(
          <label key={p.id} onClick={()=>setReturnItems(prev=>prev.includes(p.id)?prev.filter(x=>x!==p.id):[...prev,p.id])}
            style={{...sbtn,padding:"6px 10px",borderRadius:8,cursor:"pointer",
              background:returnItems.includes(p.id)?"rgba(239,68,68,.15)":"transparent",
              borderColor:returnItems.includes(p.id)?"rgba(239,68,68,.4)":C.b,
              color:returnItems.includes(p.id)?C.d:C.td}}>
            {p.img} {p.name} <span style={{color:C.tm,marginLeft:4}}>Rs.{p.price}</span>
          </label>
        ))}
      </div>
      {returnItems.length>0&&<div style={{background:C.s,borderRadius:8,padding:12,marginBottom:12}}>
        <div style={{fontSize:12,color:C.td}}>Refund: <b style={{color:C.d,fontSize:16}}>Rs.{products.filter(p=>returnItems.includes(p.id)).reduce((s,p)=>s+p.price,0).toLocaleString()}</b> | Items: {returnItems.length} | Reason: {returnReason}</div>
      </div>}
      <div style={{display:"flex",gap:8}}>
        <button onClick={()=>{
          if(!returnInvId||returnItems.length===0) return showT("Enter invoice # and select items");
          setProducts(p=>p.map(x=>returnItems.includes(x.id)?{...x,stock:x.stock+1}:x));
          showT(`✓ Refund Rs.${products.filter(p=>returnItems.includes(p.id)).reduce((s,p)=>s+p.price,0).toLocaleString()} processed. Stock restored.`);
          setReturnItems([]);setReturnInvId("");setShowReturn(false);
        }} style={{...sbtn,background:C.d,color:"#fff",border:"none",padding:"10px 18px",borderRadius:8}}>💰 Refund</button>
        <button onClick={()=>{
          if(!returnInvId||returnItems.length===0) return showT("Enter invoice # and select items");
          showT("✓ Exchange processed — customer picks replacement");
          setReturnItems([]);setReturnInvId("");setShowReturn(false);
        }} style={{...sbtn,background:C.w,color:"#000",border:"none",padding:"10px 18px",borderRadius:8}}>🔄 Exchange</button>
      </div>
    </div></div>}

    {/* ===== Print Preview Overlay ===== */}
    {showPrintPreview&&(
      <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,.7)",zIndex:998,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{background:"#fff",borderRadius:14,padding:24,maxWidth:360,width:"100%",maxHeight:"80vh",overflow:"auto",color:"#000"}}>
          <div id="receipt-print" style={{fontFamily:"monospace",fontSize:11,lineHeight:1.6}}>
            <div style={{textAlign:"center",borderBottom:"1px dashed #ccc",paddingBottom:8,marginBottom:6}}>
              {receipt.showLogo&&(
                receipt.logoType==="image"&&receipt.logoImage?
                  <img src={receipt.logoImage} alt="" style={{maxHeight:50,maxWidth:140,margin:"0 auto 4px",display:"block"}}/>
                  :<div style={{display:"inline-block",padding:receipt.logoText.length>6?"4px 10px":"6px 10px",borderRadius:6,background:"#000",color:"#fff",fontWeight:800,fontSize:receipt.logoText.length>10?11:14,marginBottom:4}}>{receipt.logoText}</div>
              )}
              <div style={{fontWeight:700,fontSize:14}}>{receipt.businessName}</div>
              {receipt.showAddress&&<div style={{fontSize:10,color:"#666"}}>{receipt.address}</div>}
              {receipt.showPhone&&<div style={{fontSize:10,color:"#666"}}>Tel: {receipt.phone}</div>}
              {receipt.showEmail&&<div style={{fontSize:10,color:"#666"}}>{receipt.email}</div>}
            </div>
            <div style={{fontSize:10,color:"#666",marginBottom:4}}>Date: {new Date().toLocaleDateString()} | Cashier: {currentUser.name}</div>
            {selectedCustomer&&<div style={{fontSize:10,marginBottom:4}}>Customer: {selectedCustomer.name} | {selectedCustomer.phone}</div>}
            <div style={{borderBottom:"1px dashed #ccc",paddingBottom:4,marginBottom:4}}>
              {cartLines.map((i,idx)=>(
                <div key={idx} style={{display:"flex",justifyContent:"space-between"}}><span>{i.name} x{i.qty}</span><span>Rs.{i.lineGrand.toLocaleString()}</span></div>
              ))}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:14,borderTop:"2px solid #000",paddingTop:4}}>
              <span>TOTAL:</span><span>Rs.{grandTotal.toLocaleString()}</span>
            </div>
            <div style={{fontSize:10,marginTop:4}}>Paid by: {payMethod}{isUdhar?" (UDHAR/CREDIT)":""}</div>
            {receipt.showFbrQr&&sendToFbr&&<div style={{textAlign:"center",marginTop:6}}>
              <div style={{width:45,height:45,border:"2px solid #000",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:7}}>FBR QR</div>
            </div>}
            <div style={{textAlign:"center",marginTop:6,fontSize:9,color:"#666"}}>{receipt.tagline}</div>
          </div>
          <div style={{display:"flex",gap:6,marginTop:14,borderTop:"1px solid #eee",paddingTop:12}}>
            <button onClick={doPrint} style={{flex:1,padding:10,borderRadius:8,border:"none",background:"#10B981",color:"#fff",fontWeight:700,cursor:"pointer"}}>🖨️ Print</button>
            <button onClick={()=>{
              const el=document.getElementById("receipt-print");
              if(el){navigator.clipboard?.writeText(el.innerText);showT("✓ Receipt text copied to clipboard")}
            }} style={{flex:1,padding:10,borderRadius:8,border:"1px solid #ddd",background:"#fff",color:"#333",fontWeight:600,cursor:"pointer"}}>📋 Copy text</button>
            <button onClick={()=>setShowPrintPreview(false)} style={{padding:10,borderRadius:8,border:"1px solid #ddd",background:"#fff",color:"#666",cursor:"pointer"}}>✕</button>
          </div>
        </div>
      </div>
    )}

    <div style={{padding:16}}>

    {/* Stock alerts bar */}
    {products.filter(p=>p.stock<LOW_STOCK_THRESHOLD).length>0&&(
      <div style={{background:"rgba(245,158,11,.1)",border:`1px solid rgba(245,158,11,.3)`,borderRadius:10,padding:"8px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
        <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
          <span style={{fontSize:14}}>⚠️</span>
          <span style={{fontSize:11,color:C.w,fontWeight:600}}>{products.filter(p=>p.stock<LOW_STOCK_THRESHOLD).length} low stock:</span>
          <span style={{fontSize:10,color:C.td}}>{products.filter(p=>p.stock<LOW_STOCK_THRESHOLD).map(p=>`${p.img||"📦"} ${p.name} (${p.stock})`).join(" · ")}</span>
        </div>
        <button onClick={()=>setTab("products")} style={{...sbtn,fontSize:10,color:C.w,borderColor:"rgba(245,158,11,.3)"}}>View →</button>
      </div>
    )}
    {products.filter(p=>p.stock<LOW_STOCK_THRESHOLD).length>0&&(
      <div style={{background:"rgba(245,158,11,.1)",border:`1px solid rgba(245,158,11,.3)`,borderRadius:10,padding:"8px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
        <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
          <span style={{fontSize:14}}>⚠️</span>
          <span style={{fontSize:11,color:C.w,fontWeight:600}}>{products.filter(p=>p.stock<LOW_STOCK_THRESHOLD).length} low stock:</span>
          <span style={{fontSize:10,color:C.td}}>{products.filter(p=>p.stock<LOW_STOCK_THRESHOLD).map(p=>`${p.img||"📦"} ${p.name} (${p.stock})`).join(" · ")}</span>
        </div>
        <button onClick={()=>setTab("products")} style={{...sbtn,fontSize:10,color:C.w,borderColor:"rgba(245,158,11,.3)"}}>View →</button>
      </div>
    )}

    {/* ===================== POS TAB ===================== */}
    {tab==="pos"&&(
      <div style={{display:"grid",gridTemplateColumns:"1fr 320px",gap:16}}>
        <div>
          {/* Search + Scan */}
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search products or type barcode..." style={{...inp,flex:1}}/>
            <button onClick={()=>{setShowBarcodeScan(true);setTimeout(()=>barcodeRef.current?.focus(),100)}} style={{...sbtn,background:C.a,color:"#fff",padding:"8px 14px",border:"none"}}>📷 Scan</button>
          </div>
          {/* Product grid */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(145px,1fr))",gap:8}}>
            {filtered.map(p=>{
              const disc=getDiscount(p);
              return(
              <button key={p.id} onClick={()=>addToCart(p)} style={{background:C.card,border:`1px solid ${C.b}`,borderRadius:10,padding:10,cursor:"pointer",textAlign:"left",color:C.t,display:"flex",flexDirection:"column",gap:4,position:"relative"}}>
                {disc>0&&<div style={{position:"absolute",top:6,right:6,background:C.d,color:"#fff",fontSize:9,fontWeight:700,padding:"2px 5px",borderRadius:4}}>-{disc}%</div>}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:9,fontWeight:700,color:C.a,background:"rgba(59,130,246,.1)",padding:"1px 6px",borderRadius:3}}>{p.cat}</span>
                  {p.imageUrl?<img src={p.imageUrl} alt="" style={{width:28,height:28,objectFit:"cover",borderRadius:6}}/>:<span style={{fontSize:22}}>{p.img||"📦"}</span>}
                </div>
                <span style={{fontSize:12,fontWeight:600,lineHeight:1.2}}>{p.name}</span>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:"auto",alignItems:"center"}}>
                  <div>{disc>0&&<span style={{fontSize:10,textDecoration:"line-through",color:C.tm,marginRight:4}}>Rs.{p.price}</span>}
                    <span style={{fontSize:14,fontWeight:700,color:C.p}}>Rs.{disc>0?Math.round(p.price*(1-disc/100)):p.price}</span></div>
                  <span style={{fontSize:9,color:p.stock<35?C.w:C.tm}}>{p.stock}</span>
                </div>
              </button>);
            })}
          </div>
        </div>

        {/* CART PANEL */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,display:"flex",flexDirection:"column",overflow:"hidden",maxHeight:"82vh"}}>
          {/* Customer selector — enhanced with visit/spend info */}
          <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.b}`,background:"rgba(59,130,246,.05)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <span style={{fontSize:11,fontWeight:600,color:C.td}}>👤 CUSTOMER</span>
              <button onClick={()=>setShowAddCustomer(true)} style={{...sbtn,fontSize:10,padding:"2px 8px"}}>+ New</button>
            </div>
            {selectedCustomer?(
              <div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:6}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13}}>{selectedCustomer.name}</div>
                    <div style={{fontSize:10,color:C.td}}>📱 {selectedCustomer.phone}</div>
                    {selectedCustomer.email&&<div style={{fontSize:10,color:C.tm}}>✉️ {selectedCustomer.email}</div>}
                  </div>
                  <button onClick={()=>setSelectedCustomer(null)} style={{...sbtn,fontSize:10,color:C.d,borderColor:"rgba(239,68,68,.3)"}}>✕</button>
                </div>
                <div style={{display:"flex",gap:6}}>
                  <div style={{flex:1,background:C.s,borderRadius:6,padding:"5px 8px",textAlign:"center"}}>
                    <div style={{fontSize:9,color:C.tm}}>Visit #</div>
                    <div style={{fontSize:14,fontWeight:800,color:C.a}}>{selectedCustomer.visits+1}<span style={{fontSize:9,color:C.td,fontWeight:400}}>th</span></div>
                  </div>
                  <div style={{flex:1,background:C.s,borderRadius:6,padding:"5px 8px",textAlign:"center"}}>
                    <div style={{fontSize:9,color:C.tm}}>Total spent</div>
                    <div style={{fontSize:12,fontWeight:700,color:C.p}}>Rs.{selectedCustomer.totalSpent.toLocaleString()}</div>
                  </div>
                  <div style={{flex:1,background:C.s,borderRadius:6,padding:"5px 8px",textAlign:"center"}}>
                    <div style={{fontSize:9,color:C.tm}}>Tier</div>
                    <div style={{fontSize:11,fontWeight:700,color:selectedCustomer.totalSpent>=40000?C.w:selectedCustomer.totalSpent>=20000?C.purple:C.td}}>
                      {selectedCustomer.totalSpent>=40000?"⭐ Gold":selectedCustomer.totalSpent>=20000?"💎 Silver":"🔵 Regular"}
                    </div>
                  </div>
                </div>
              </div>
            ):(
              <div>
                <input value={customerSearch} onChange={e=>setCustSearch(e.target.value)} placeholder="Type name or phone number..." style={{...inp,fontSize:11,padding:"6px 8px"}}/>
                {customerSearch&&<div style={{maxHeight:140,overflow:"auto",marginTop:4,borderRadius:6,border:`1px solid ${C.b}`}}>
                  {filteredCusts.length>0?filteredCusts.map(c=>(
                    <div key={c.id} onClick={()=>{setSelectedCustomer(c);setCustSearch("")}} style={{padding:"7px 10px",cursor:"pointer",fontSize:11,borderBottom:`1px solid ${C.b}`,background:C.s,transition:"background .1s"}}
                      onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background=C.s}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{fontWeight:600}}>{c.name}</span>
                        <span style={{fontSize:10,color:c.totalSpent>=40000?C.w:c.totalSpent>=20000?C.purple:C.tm}}>
                          {c.totalSpent>=40000?"⭐ Gold":c.totalSpent>=20000?"💎 Silver":""}
                        </span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
                        <span style={{color:C.tm}}>📱 {c.phone}</span>
                        <span style={{color:C.td}}>{c.visits} visits · Rs.{c.totalSpent.toLocaleString()}</span>
                      </div>
                    </div>
                  )):<div style={{padding:"10px",fontSize:11,color:C.tm,textAlign:"center",background:C.s}}>
                    No customer found — <span onClick={()=>{setNewCust(p=>({...p,phone:customerSearch.match(/\d/)?customerSearch:"",name:customerSearch.match(/\d/)?"":customerSearch}));setShowAddCustomer(true);setCustSearch("")}} style={{color:C.a,cursor:"pointer",textDecoration:"underline"}}>add new?</span>
                  </div>}
                </div>}
              </div>
            )}
          </div>

          {/* Cart header */}
          <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.b}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,fontSize:14}}>🧾 Sale ({cart.length})</span>
            {/* FBR TOGGLE */}
            <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:11,fontWeight:600,color:sendToFbr?C.p:C.d}}>
              <span>{sendToFbr?"FBR ✓":"FBR ✗"}</span>
              <div onClick={()=>setSendToFbr(!sendToFbr)} style={{width:32,height:18,borderRadius:9,background:sendToFbr?C.p:C.d,position:"relative",cursor:"pointer",transition:"background .2s"}}>
                <div style={{width:14,height:14,borderRadius:7,background:"#fff",position:"absolute",top:2,left:sendToFbr?16:2,transition:"left .2s"}}/>
              </div>
            </label>
          </div>

          {/* Cart items */}
          <div style={{flex:1,overflow:"auto",padding:"6px 12px"}}>
            {cart.length===0?<div style={{textAlign:"center",padding:"24px 0",color:C.tm,fontSize:12}}>Tap products to add</div>:
            cartLines.map(i=>(
              <div key={i.id} style={{padding:"6px 0",borderBottom:`1px solid ${C.b}`,fontSize:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"start"}}>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:600,fontSize:12}}>{i.name}</div>
                    <div style={{color:C.tm,fontSize:10}}>
                      Rs.{i.price}×{i.qty} {i.discPct>0&&<span style={{color:C.d}}>(-{i.discPct}%)</span>} +{i.gstRate}% GST
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <button onClick={()=>setCart(p=>p.map(x=>x.id===i.id?{...x,qty:Math.max(1,x.qty-1)}:x))} style={sbtn}>−</button>
                    <span style={{width:20,textAlign:"center",fontWeight:700}}>{i.qty}</span>
                    <button onClick={()=>setCart(p=>p.map(x=>x.id===i.id?{...x,qty:x.qty+1}:x))} style={sbtn}>+</button>
                    <span style={{width:55,textAlign:"right",fontWeight:700,color:C.p,fontSize:12}}>Rs.{i.lineGrand.toLocaleString()}</span>
                    <button onClick={()=>setCart(p=>p.filter(x=>x.id!==i.id))} style={{...sbtn,color:C.d,borderColor:"rgba(239,68,68,.3)",fontSize:10}}>✕</button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Cart footer */}
          {cart.length>0&&(
            <div style={{padding:"10px 12px",borderTop:`1px solid ${C.b}`,background:"rgba(16,185,129,.04)"}}>
              {totalDisc>0&&<Row l="Product discounts" v={`-Rs.${totalDisc.toLocaleString()}`} c={C.d}/>}
              <Row l="Subtotal" v={`Rs.${subtotal.toLocaleString()}`}/>
              <Row l="GST" v={`Rs.${totalTax.toLocaleString()}`}/>
              <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                <span style={{fontSize:11,color:C.td,flex:1}}>Extra discount %</span>
                <input type="number" min="0" max="100" value={manualDiscount||""} onChange={e=>setManualDiscount(Math.min(100,+e.target.value||0))}
                  style={{...inp,width:50,padding:"4px 6px",textAlign:"center",fontSize:11}}/>
                {extraDisc>0&&<span style={{fontSize:11,color:C.d}}>-Rs.{extraDisc.toLocaleString()}</span>}
              </div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:16,fontWeight:800,color:C.p,paddingTop:8,borderTop:`2px solid ${C.p}`}}>
                <span>TOTAL</span><span>Rs.{grandTotal.toLocaleString()}</span>
              </div>
              {/* Multi-payment selector */}
              <div style={{display:"flex",gap:4,marginTop:8}}>
                {[{id:"cash",l:"💵 Cash",c:C.p},{id:"card",l:"💳 Card",c:C.a},{id:"mobile",l:"📱 Mobile",c:C.purple},{id:"split",l:"✂️ Split",c:C.w}].map(m=>(
                  <button key={m.id} onClick={()=>setPayMethod(m.id)} style={{flex:1,padding:"6px 4px",borderRadius:6,border:"none",cursor:"pointer",fontSize:10,fontWeight:700,
                    background:payMethod===m.id?m.c+"22":"transparent",color:payMethod===m.id?m.c:C.tm,
                    outline:payMethod===m.id?`2px solid ${m.c}`:`1px solid ${C.b}`}}>{m.l}</button>
                ))}
              </div>
              {payMethod==="split"&&(
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginTop:6}}>
                  <div><label style={{fontSize:9,color:C.tm}}>Cash</label><input type="number" style={{...inp,padding:"4px 6px",fontSize:11}} value={paySplit.cash} onChange={e=>setPaySplit(p=>({...p,cash:e.target.value}))} placeholder="0"/></div>
                  <div><label style={{fontSize:9,color:C.tm}}>Card</label><input type="number" style={{...inp,padding:"4px 6px",fontSize:11}} value={paySplit.card} onChange={e=>setPaySplit(p=>({...p,card:e.target.value}))} placeholder="0"/></div>
                  <div><label style={{fontSize:9,color:C.tm}}>Mobile</label><input type="number" style={{...inp,padding:"4px 6px",fontSize:11}} value={paySplit.mobile} onChange={e=>setPaySplit(p=>({...p,mobile:e.target.value}))} placeholder="0"/></div>
                </div>
              )}
              <button onClick={()=>{
                if(isUdhar&&!selectedCustomer) return showT("Select a customer for Udhar");
                if(isUdhar&&selectedCustomer){
                  setUdharLedger(prev=>[{id:Date.now(),custId:selectedCustomer.id,custName:selectedCustomer.name,custPhone:selectedCustomer.phone,
                    date:new Date().toISOString().slice(0,10),items:cart.map(i=>({name:i.name,qty:i.qty,price:i.price})),total:grandTotal,paid:0,status:"unpaid"},...prev]);
                }
                handleCheckout();setPayMethod("cash");setPaySplit({cash:"",card:"",mobile:""});setIsUdhar(false);
              }} style={{width:"100%",padding:10,marginTop:8,borderRadius:8,border:"none",background:isUdhar?`linear-gradient(135deg,${C.w},#D97706)`:`linear-gradient(135deg,${C.p},${C.pd})`,color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                {isUdhar?"Add to Udhar (Credit) →":`Complete Sale (${payMethod==="split"?"Split":payMethod==="card"?"Card":payMethod==="mobile"?"Mobile":"Cash"}) ${sendToFbr?"& FBR":""} →`}
              </button>
              <label onClick={()=>setIsUdhar(!isUdhar)} style={{display:"flex",alignItems:"center",gap:6,marginTop:6,cursor:"pointer",fontSize:11,fontWeight:600,color:isUdhar?C.w:C.tm,padding:"4px 8px",borderRadius:6,background:isUdhar?"rgba(245,158,11,.1)":"transparent",border:`1px solid ${isUdhar?"rgba(245,158,11,.3)":C.b}`}}>
                <div style={{width:16,height:16,borderRadius:4,border:`2px solid ${isUdhar?C.w:C.b}`,background:isUdhar?C.w:"transparent",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"#fff"}}>{isUdhar?"✓":""}</div>
                📒 Udhar (Customer pays later)
              </label>
              <div style={{display:"flex",gap:4,marginTop:4}}>
                <button onClick={printReceipt} style={{flex:1,padding:6,borderRadius:6,border:`1px solid ${C.b}`,background:C.s,color:C.td,fontSize:11,fontWeight:600,cursor:"pointer"}}>
                  🖨️ Print
                </button>
                <button onClick={()=>setShowReturn(true)} style={{flex:1,padding:6,borderRadius:6,border:`1px solid rgba(239,68,68,.3)`,background:"rgba(239,68,68,.08)",color:C.d,fontSize:11,fontWeight:600,cursor:"pointer"}}>
                  ↩️ Return
                </button>
              </div>
              <div style={{fontSize:9,color:C.tm,marginTop:4,textAlign:"center"}}>Cashier: {currentUser.name} ({currentUser.role})</div>
            </div>
          )}
        </div>
      </div>
    )}

    {/* ===================== PRODUCTS TAB ===================== */}
    {tab==="products"&&(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>📦 Product Management</h2>
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>setShowAddProduct(true)} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 14px"}}>+ Add Product</button>
            <button onClick={()=>setShowAddCat(true)} style={{...sbtn,background:C.purple,color:"#fff",border:"none",padding:"8px 14px"}}>+ Category</button>
            <button onClick={()=>setShowAddGst(true)} style={{...sbtn,background:C.w,color:"#000",border:"none",padding:"8px 14px"}}>+ GST Rule</button>
            <button onClick={()=>setShowBulkImport(true)} style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"8px 14px"}}>📁 Bulk Import</button>
            <button onClick={()=>{setShowBarcodeScan(true);setTimeout(()=>barcodeRef.current?.focus(),100)}} style={{...sbtn,background:"#374151",color:"#fff",border:"none",padding:"8px 14px"}}>📷 Scan Barcode</button>
          </div>
        </div>

        {/* Smart Command Bar */}
        <div style={{background:C.card,borderRadius:10,border:`1px solid ${C.b}`,padding:"10px 14px",marginBottom:12}}>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <span style={{fontSize:14}}>⚡</span>
            <input value={cmdInput} onChange={e=>setCmdInput(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&cmdInput&&processCmd(cmdInput)}
              placeholder='Type: add 10 surf excel  or  set pepsi price 200  or  reduce rice 5'
              style={{...inp,flex:1,border:"none",background:"transparent",fontSize:13,padding:"6px 0"}}/>
            <button onClick={()=>cmdInput&&processCmd(cmdInput)} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"6px 14px",borderRadius:6}}>Run ⏎</button>
          </div>
          <div style={{fontSize:10,color:C.tm,marginTop:4,display:"flex",gap:12,flexWrap:"wrap"}}>
            <span>Commands:</span>
            {["add 50 pepsi","set tapal price 700","reduce rice 10","update surf stock 200"].map(ex=>(
              <span key={ex} onClick={()=>{setCmdInput(ex)}} style={{color:C.a,cursor:"pointer",textDecoration:"underline"}}>{ex}</span>
            ))}
          </div>
        </div>

        {/* Modals */}
        {showAddCat&&<Modal title="Add new category" onClose={()=>setShowAddCat(false)}>
          <label style={lbl}>Category name</label>
          <input style={inp} value={newCat} onChange={e=>setNewCat(e.target.value)} placeholder="e.g. Electronics, Cosmetics..."/>
          <div style={{marginTop:8,fontSize:11,color:C.tm}}>Existing: {categories.join(", ")}</div>
          <button onClick={handleAddCat} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px",marginTop:12}}>Save Category</button>
        </Modal>}

        {showAddGst&&<Modal title="Add GST / Tax rule" onClose={()=>setShowAddGst(false)}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label style={lbl}>Rule name</label><input style={inp} value={newGst.name} onChange={e=>setNewGst(p=>({...p,name:e.target.value}))} placeholder="e.g. Luxury Tax"/></div>
            <div><label style={lbl}>Rate (%)</label><input style={inp} type="number" value={newGst.rate} onChange={e=>setNewGst(p=>({...p,rate:e.target.value}))} placeholder="e.g. 25"/></div>
          </div>
          <div style={{marginTop:8,fontSize:11,color:C.tm}}>Existing rules: {gstRules.map(g=>`${g.name} (${g.rate}%)`).join(", ")}</div>
          <button onClick={handleAddGst} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px",marginTop:12}}>Save GST Rule</button>
        </Modal>}

        {showBulkImport&&<Modal title="📁 Import products from file" onClose={()=>setShowBulkImport(false)} wide>
          <div style={{fontSize:12,color:C.td,marginBottom:10,lineHeight:1.6}}>
            Upload an <b>Excel (.xlsx, .csv)</b> file or paste CSV data below. Your file must have these columns in this exact order:
          </div>
          <div style={{background:C.s,borderRadius:8,padding:12,marginBottom:12,fontFamily:"monospace",fontSize:11,overflowX:"auto",border:`1px solid ${C.b}`}}>
            <div style={{color:C.w,fontWeight:700,marginBottom:4}}>Required columns:</div>
            <div><span style={{color:C.p}}>name</span> , <span style={{color:C.p}}>barcode</span> , <span style={{color:C.p}}>price</span> , <span style={{color:C.p}}>cost</span> , <span style={{color:C.p}}>stock</span> , <span style={{color:C.p}}>category</span> , <span style={{color:C.p}}>gst_rate</span></div>
          </div>
          {/* File upload */}
          <div style={{display:"flex",gap:10,marginBottom:12,alignItems:"center"}}>
            <label style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"10px 18px",cursor:"pointer",borderRadius:8,display:"flex",alignItems:"center",gap:6}}>
              📂 Choose file (.csv / .xlsx)
              <input type="file" accept=".csv,.xlsx,.xls,.txt" style={{display:"none"}} onChange={e=>{
                const file=e.target.files[0];if(!file) return;
                const reader=new FileReader();
                reader.onload=ev=>{
                  const text=ev.target.result;
                  setBulkCsv(text);
                  const lineCount=text.trim().split("\n").length-1;
                  showT(`✓ File "${file.name}" loaded — ${lineCount} product rows found`);
                };
                reader.readAsText(file);
              }}/>
            </label>
            <span style={{fontSize:11,color:C.tm}}>or paste data manually below</span>
          </div>
          <textarea value={bulkCsv} onChange={e=>setBulkCsv(e.target.value)} placeholder="name,barcode,price,cost,stock,category,gst_rate&#10;Colgate Toothpaste,890125,250,180,100,Home,17&#10;Peak Milk Powder,890126,850,700,50,Dairy,0"
            style={{...inp,height:150,fontFamily:"monospace",fontSize:11,resize:"vertical"}}/>
          <div style={{display:"flex",gap:8,marginTop:12,flexWrap:"wrap"}}>
            <button onClick={handleBulkImport} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"10px 18px",fontSize:13}}>
              ✓ Import {Math.max(0,bulkCsv.trim().split("\n").length-1)} Products
            </button>
            <button onClick={()=>{setBulkCsv("name,barcode,price,cost,stock,category,gst_rate\nColgate Toothpaste 200g,890125678,250,180,100,Home,17\nPeak Milk Powder 400g,890126789,850,700,50,Dairy,0\nMitchells Ketchup 500g,890127890,380,290,80,Home,17\nSafeguard Soap 3-Pack,890128901,320,250,200,Home,17\nTang Orange 750g,890129012,550,420,90,Beverages,17");showT("✓ Sample with 5 products loaded")}}
              style={{...sbtn,padding:"10px 18px"}}>Load Sample (5 products)</button>
            <button onClick={()=>{
              const tpl="name,barcode,price,cost,stock,category,gst_rate\n,,,,,,";
              const blob=new Blob([tpl],{type:"text/csv"});
              const a=document.createElement("a");a.href=URL.createObjectURL(blob);a.download="BillKaro_Import_Template.csv";a.click();
              showT("✓ Template downloaded — fill it in Excel and upload");
            }} style={{...sbtn,padding:"10px 18px",background:"rgba(139,92,246,.15)",color:C.purple,border:`1px solid rgba(139,92,246,.3)`}}>
              📥 Download template (.csv)
            </button>
          </div>
        </Modal>}

        {showBarcodeScan&&<Modal title="📷 Barcode scanner" onClose={()=>setShowBarcodeScan(false)}>
          <div style={{fontSize:11,color:C.td,marginBottom:8}}>Type or scan a barcode. If product exists, it adds to cart. If not, you can add it as new.</div>
          <div style={{display:"flex",gap:8}}>
            <input ref={barcodeRef} value={barcodeInput} onChange={e=>setBarcodeInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleBarcodeScan()} placeholder="Scan or type barcode..." style={{...inp,flex:1,fontSize:16,fontFamily:"monospace",letterSpacing:2}}/>
            <button onClick={handleBarcodeScan} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px"}}>Search</button>
          </div>
          <div style={{marginTop:10,fontSize:10,color:C.tm}}>Try: 8901233012345 (Dairy Milk) or type any new barcode</div>
        </Modal>}

        {showAddProduct&&<Modal title="Add new product" onClose={()=>setShowAddProduct(false)} wide>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            <div><label style={lbl}>Product name *</label><input style={inp} value={newProd.name} onChange={e=>setNewProd(p=>({...p,name:e.target.value}))} placeholder="e.g. Tapal Danedar 200g"/></div>
            <div><label style={lbl}>Barcode</label><input style={inp} value={newProd.barcode} onChange={e=>setNewProd(p=>({...p,barcode:e.target.value}))} placeholder="Auto-generated if empty"/></div>
            <div><label style={lbl}>Category</label>
              <select style={inp} value={newProd.cat} onChange={e=>setNewProd(p=>({...p,cat:e.target.value}))}>
                {categories.map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
            <div><label style={lbl}>Selling price (Rs.) *</label><input style={inp} type="number" value={newProd.price} onChange={e=>setNewProd(p=>({...p,price:e.target.value}))} placeholder="0"/></div>
            <div><label style={lbl}>Cost price (Rs.)</label><input style={inp} type="number" value={newProd.cost} onChange={e=>setNewProd(p=>({...p,cost:e.target.value}))} placeholder="0"/></div>
            <div><label style={lbl}>Opening stock</label><input style={inp} type="number" value={newProd.stock} onChange={e=>setNewProd(p=>({...p,stock:e.target.value}))} placeholder="0"/></div>
            <div><label style={lbl}>GST / Tax rule</label>
              <select style={inp} value={newProd.gstId} onChange={e=>setNewProd(p=>({...p,gstId:+e.target.value}))}>
                {gstRules.map(g=><option key={g.id} value={g.id}>{g.name} ({g.rate}%)</option>)}
              </select>
            </div>
            <div><label style={lbl}>Product icon or image</label>
              <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:6}}>
                <label style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"6px 12px",cursor:"pointer",borderRadius:6,display:"inline-flex",alignItems:"center",gap:4}}>
                  📷 Upload image
                  <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                    const file=e.target.files[0];if(!file)return;
                    const reader=new FileReader();
                    reader.onload=ev=>setNewProd(p=>({...p,imageUrl:ev.target.result,img:""}));
                    reader.readAsDataURL(file);showT("✓ Product image uploaded");
                  }}/>
                </label>
                {newProd.imageUrl&&<img src={newProd.imageUrl} alt="" style={{height:32,width:32,objectFit:"cover",borderRadius:6,border:`1px solid ${C.b}`}}/>}
                {newProd.imageUrl&&<button onClick={()=>setNewProd(p=>({...p,imageUrl:"",img:"📦"}))} style={{...sbtn,fontSize:10,color:C.d}}>✕ Remove</button>}
              </div>
              <div style={{fontSize:10,color:C.tm,marginBottom:4}}>Or pick an icon:</div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                {["📦","🍫","🥛","🍞","🥤","🍵","🌶️","🧴","🫗","🍚","🥩","💊","🧀","🍪","🧃","🍌","🥚","🧈"].map(e=>(
                  <button key={e} type="button" onClick={()=>setNewProd(p=>({...p,img:e,imageUrl:""}))}
                    style={{width:28,height:28,borderRadius:5,border:newProd.img===e&&!newProd.imageUrl?`2px solid ${C.p}`:`1px solid ${C.b}`,background:newProd.img===e&&!newProd.imageUrl?"rgba(16,185,129,.15)":C.s,
                      cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center"}}>{e}</button>
                ))}
              </div>
            </div>
          </div>
          <button onClick={handleAddProd} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 20px",marginTop:14}}>Save Product</button>
        </Modal>}

        {/* Smart command bar */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:14,marginBottom:12}}>
          <label style={{...lbl,marginBottom:6}}>⚡ Quick command — type a command and press Enter</label>
          <div style={{display:"flex",gap:8}}>
            <input value={cmdText} onChange={e=>setCmdText(e.target.value)} onKeyDown={e=>{
              if(e.key!=="Enter"||!cmdText.trim()) return;
              const cmd=cmdText.toLowerCase().trim();
              // Parse: "update <product> stock <number>" or "set <product> price <number>"
              const stockMatch=cmd.match(/(?:update|set|change|add)\s+(.+?)\s+stock\s+(\d+)/i);
              const priceMatch=cmd.match(/(?:update|set|change)\s+(.+?)\s+price\s+(\d+)/i);
              const addStockMatch=cmd.match(/(?:add|increase)\s+(\d+)\s+(?:to|in|stock)\s+(.+)/i);
              if(stockMatch){
                const[,name,val]=stockMatch;
                const p=products.find(x=>x.name.toLowerCase().includes(name.trim()));
                if(p){setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:+val}:x));showT(`✓ ${p.name} stock → ${val}`)}
                else showT(`Product "${name}" not found`);
              }else if(priceMatch){
                const[,name,val]=priceMatch;
                const p=products.find(x=>x.name.toLowerCase().includes(name.trim()));
                if(p){setProducts(pr=>pr.map(x=>x.id===p.id?{...x,price:+val}:x));showT(`✓ ${p.name} price → Rs.${val}`)}
                else showT(`Product "${name}" not found`);
              }else if(addStockMatch){
                const[,val,name]=addStockMatch;
                const p=products.find(x=>x.name.toLowerCase().includes(name.trim()));
                if(p){setProducts(pr=>pr.map(x=>x.id===p.id?{...x,stock:x.stock+ +val}:x));showT(`✓ ${p.name} stock +${val} → ${p.stock+ +val}`)}
                else showT(`Product "${name}" not found`);
              }else{
                showT("Try: \"update Pepsi stock 200\" or \"set Tapal price 700\" or \"add 50 to Milk\"");
              }
              setCmdText("");
            }} placeholder='Try: "update Pepsi stock 200" or "set Tapal price 700" or "add 50 to Guard Rice"'
              style={{...inp,flex:1,fontSize:13,fontFamily:"monospace"}}/>
            <button onClick={()=>{if(cmdText)document.dispatchEvent(new KeyboardEvent("keydown",{key:"Enter"}));else showT('Type a command like: "update Dairy Milk stock 100"')}}
              style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px"}}>Run ⚡</button>
          </div>
          <div style={{fontSize:10,color:C.tm,marginTop:6}}>
            Commands: <span style={{color:C.td}}>"update [name] stock [qty]"</span> · <span style={{color:C.td}}>"set [name] price [amount]"</span> · <span style={{color:C.td}}>"add [qty] to [name]"</span>
          </div>
        </div>

        {/* Product table with edit */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,overflow:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",minWidth:700}}>
            <thead><tr style={{borderBottom:`2px solid ${C.b}`}}>
              {["","Product","Barcode","Category","Price","Cost","GST","Stock","Discount","Actions"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,textTransform:"uppercase",color:C.tm}}>{h}</th>
              ))}</tr></thead>
            <tbody>{products.map(p=>{const disc=getDiscount(p);const gst=gstRules.find(g=>g.id===p.gstId);const isEditing=editProdId===p.id;return(
              <tr key={p.id} style={{borderBottom:`1px solid ${C.b}`,background:isEditing?"rgba(16,185,129,.06)":"transparent"}}>
                <td style={{padding:"8px 12px",fontSize:18}}>{p.imageUrl?<img src={p.imageUrl} alt="" style={{width:24,height:24,objectFit:"cover",borderRadius:4}}/>:p.img||"📦"}</td>
                <td style={{padding:"8px 12px",fontWeight:600,fontSize:12}}>{p.name}</td>
                <td style={{padding:"8px 12px",fontSize:11,color:C.td,fontFamily:"monospace"}}>{p.barcode}</td>
                <td style={{padding:"8px 12px"}}><span style={{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:4,background:"rgba(59,130,246,.1)",color:C.a}}>{p.cat}</span></td>
                <td style={{padding:"8px 12px"}}>{isEditing?
                  <input type="number" value={editProdData.price??p.price} onChange={e=>setEditProdData(d=>({...d,price:e.target.value}))} style={{...inp,width:70,padding:"4px 6px",fontSize:12}}/>
                  :<span style={{fontWeight:700,color:C.p}}>Rs.{p.price}</span>}</td>
                <td style={{padding:"8px 12px"}}>{isEditing?
                  <input type="number" value={editProdData.cost??p.cost} onChange={e=>setEditProdData(d=>({...d,cost:e.target.value}))} style={{...inp,width:60,padding:"4px 6px",fontSize:11}}/>
                  :<span style={{fontSize:11,color:C.td}}>Rs.{p.cost}</span>}</td>
                <td style={{padding:"8px 12px",fontSize:11}}>{gst?`${gst.name} (${gst.rate}%)`:"—"}</td>
                <td style={{padding:"8px 12px"}}>{isEditing?
                  <input type="number" value={editProdData.stock??p.stock} onChange={e=>setEditProdData(d=>({...d,stock:e.target.value}))} style={{...inp,width:60,padding:"4px 6px",fontSize:12,fontWeight:700}}/>
                  :<span style={{fontWeight:600,color:p.stock<35?C.w:C.t}}>{p.stock}</span>}</td>
                <td style={{padding:"8px 12px"}}>{disc>0?<span style={{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:4,background:"rgba(239,68,68,.15)",color:C.d}}>-{disc}%</span>:<span style={{color:C.tm,fontSize:10}}>—</span>}</td>
                <td style={{padding:"8px 12px"}}>
                  {isEditing?(
                    <div style={{display:"flex",gap:4}}>
                      <button onClick={()=>{
                        setProducts(pr=>pr.map(x=>x.id===p.id?{...x,
                          price:+(editProdData.price??p.price),
                          cost:+(editProdData.cost??p.cost),
                          stock:+(editProdData.stock??p.stock)}:x));
                        showT(`✓ ${p.name} updated`);setEditProdId(null);setEditProdData({});
                      }} style={{...sbtn,fontSize:10,padding:"3px 8px",background:C.p,color:"#fff",border:"none"}}>✓ Save</button>
                      <button onClick={()=>{setEditProdId(null);setEditProdData({})}} style={{...sbtn,fontSize:10,padding:"3px 8px"}}>✕</button>
                    </div>
                  ):(
                    <div style={{display:"flex",gap:3}}>
                      <button onClick={()=>{setEditProdId(p.id);setEditProdData({price:p.price,cost:p.cost,stock:p.stock})}}
                        style={{...sbtn,fontSize:10,padding:"3px 8px",color:C.a,borderColor:"rgba(59,130,246,.3)"}}>✏️</button>
                      <button onClick={()=>deleteProd(p.id)}
                        style={{...sbtn,fontSize:10,padding:"3px 8px",color:C.d,borderColor:"rgba(239,68,68,.3)"}}>🗑️</button>
                    </div>
                  )}
                </td>
              </tr>);})}</tbody>
          </table>
        </div>
      </div>
    )}

    {/* ===================== CUSTOMERS TAB ===================== */}
    {tab==="customers"&&(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>👥 Customer Management</h2>
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>{setNewCust({name:"",phone:"",email:"",address:""});setEditCust(null);setShowAddCustomer(true)}} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 14px"}}>+ Add Customer</button>
            <button onClick={()=>setShowWhatsapp(true)} style={{...sbtn,background:"#25D366",color:"#fff",border:"none",padding:"8px 14px"}}>📲 WhatsApp Broadcast</button>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:12}}>
          {customers.map(c=>(
            <div key={c.id} style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:6}}>
                <div>
                  <div style={{fontWeight:700,fontSize:14}}>{c.name}</div>
                  <span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:4,
                    background:c.totalSpent>=40000?"rgba(245,158,11,.15)":c.totalSpent>=20000?"rgba(139,92,246,.15)":"rgba(100,116,139,.15)",
                    color:c.totalSpent>=40000?C.w:c.totalSpent>=20000?C.purple:C.tm}}>
                    {c.totalSpent>=40000?"⭐ Gold":c.totalSpent>=20000?"💎 Silver":"🔵 Regular"}
                  </span>
                </div>
                <div style={{display:"flex",gap:4}}>
                  <button onClick={()=>{setEditCust(c);setNewCust({name:c.name,phone:c.phone,email:c.email||"",address:c.address||""});setShowAddCustomer(true)}}
                    style={{...sbtn,fontSize:10,padding:"3px 8px",color:C.a,borderColor:"rgba(59,130,246,.3)"}}>✏️ Edit</button>
                  <a href={`https://wa.me/${(c.phone.replace(/[^0-9]/g,"").startsWith("0")?"92"+c.phone.replace(/[^0-9]/g,"").slice(1):c.phone.replace(/[^0-9]/g,""))}`}
                    target="_blank" rel="noopener noreferrer" style={{...sbtn,fontSize:10,padding:"3px 8px",color:"#25D366",borderColor:"rgba(37,211,102,.3)",textDecoration:"none"}}>📱</a>
                </div>
              </div>
              <div style={{fontSize:11,color:C.td,marginBottom:2}}>📱 {c.phone}</div>
              {c.email&&<div style={{fontSize:11,color:C.td,marginBottom:2}}>✉️ {c.email}</div>}
              {c.address&&<div style={{fontSize:11,color:C.td,marginBottom:8}}>📍 {c.address}</div>}
              <div style={{display:"flex",gap:12,paddingTop:8,borderTop:`1px solid ${C.b}`}}>
                <div><div style={{fontSize:10,color:C.tm}}>Visits</div><div style={{fontWeight:700,color:C.a}}>{c.visits}</div></div>
                <div><div style={{fontSize:10,color:C.tm}}>Total spent</div><div style={{fontWeight:700,color:C.p}}>Rs.{c.totalSpent.toLocaleString()}</div></div>
                <div><div style={{fontSize:10,color:C.tm}}>Avg. order</div><div style={{fontWeight:700,color:C.td}}>Rs.{c.visits>0?Math.round(c.totalSpent/c.visits).toLocaleString():"0"}</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {/* ===================== UDHAR / CREDIT TAB ===================== */}
    {tab==="udhar"&&(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>📒 Udhar / Credit ledger</h2>
          <div style={{fontSize:13,fontWeight:700,color:C.d}}>Total dues: Rs.{udharLedger.reduce((s,u)=>s+(u.total-u.paid),0).toLocaleString()}</div>
        </div>
        {/* Summary cards */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
          {[{l:"Total credit given",v:`Rs.${udharLedger.reduce((s,u)=>s+u.total,0).toLocaleString()}`,c:C.d},
            {l:"Amount recovered",v:`Rs.${udharLedger.reduce((s,u)=>s+u.paid,0).toLocaleString()}`,c:C.p},
            {l:"Outstanding dues",v:`Rs.${udharLedger.reduce((s,u)=>s+(u.total-u.paid),0).toLocaleString()}`,c:C.w},
            {l:"Credit customers",v:new Set(udharLedger.map(u=>u.custId)).size,c:C.a}
          ].map((s,i)=>(
            <div key={i} style={{background:C.card,borderRadius:10,padding:14,border:`1px solid ${C.b}`,borderLeft:`3px solid ${s.c}`}}>
              <div style={{fontSize:10,color:C.tm,fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{s.l}</div>
              <div style={{fontSize:22,fontWeight:800,color:s.c}}>{s.v}</div>
            </div>
          ))}
        </div>
        {/* Ledger table */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,overflow:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{borderBottom:`2px solid ${C.b}`}}>
              {["Date","Customer","Phone","Items","Total","Paid","Due","Status","Actions"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,textTransform:"uppercase",color:C.tm}}>{h}</th>
              ))}</tr></thead>
            <tbody>{udharLedger.map(u=>{const due=u.total-u.paid;return(
              <tr key={u.id} style={{borderBottom:`1px solid ${C.b}`}}>
                <td style={{padding:"8px 12px",fontSize:11}}>{u.date}</td>
                <td style={{padding:"8px 12px",fontWeight:600,fontSize:12}}>{u.custName}</td>
                <td style={{padding:"8px 12px",fontSize:11,color:C.td}}>{u.custPhone}</td>
                <td style={{padding:"8px 12px",fontSize:10,color:C.td}}>{u.items.map(i=>`${i.name}×${i.qty}`).join(", ")}</td>
                <td style={{padding:"8px 12px",fontWeight:700}}>Rs.{u.total.toLocaleString()}</td>
                <td style={{padding:"8px 12px",color:C.p,fontWeight:600}}>Rs.{u.paid.toLocaleString()}</td>
                <td style={{padding:"8px 12px",color:due>0?C.d:C.p,fontWeight:700}}>Rs.{due.toLocaleString()}</td>
                <td style={{padding:"8px 12px"}}><span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:4,
                  background:u.status==="paid"?"rgba(16,185,129,.15)":u.status==="partial"?"rgba(245,158,11,.15)":"rgba(239,68,68,.15)",
                  color:u.status==="paid"?C.p:u.status==="partial"?C.w:C.d}}>{u.status==="paid"?"✓ Paid":u.status==="partial"?"◐ Partial":"✗ Unpaid"}</span></td>
                <td style={{padding:"8px 12px"}}>
                  {udharPayId===u.id?(
                    <div style={{display:"flex",gap:3,alignItems:"center"}}>
                      <input type="number" value={udharPayAmt} onChange={e=>setUdharPayAmt(e.target.value)} placeholder="Amount" style={{...inp,width:70,padding:"3px 6px",fontSize:11}}/>
                      <button onClick={()=>{
                        if(!udharPayAmt||+udharPayAmt<=0) return showT("Enter amount");
                        const newPaid=Math.min(u.total,u.paid+(+udharPayAmt));
                        setUdharLedger(prev=>prev.map(x=>x.id===u.id?{...x,paid:newPaid,status:newPaid>=u.total?"paid":"partial"}:x));
                        showT(`✓ Rs.${(+udharPayAmt).toLocaleString()} received from ${u.custName}${newPaid>=u.total?" — FULLY PAID":""}` );
                        setUdharPayId(null);setUdharPayAmt("");
                      }} style={{...sbtn,fontSize:9,padding:"3px 6px",background:C.p,color:"#fff",border:"none"}}>✓</button>
                      <button onClick={()=>{
                        const newPaid=u.total;
                        setUdharLedger(prev=>prev.map(x=>x.id===u.id?{...x,paid:newPaid,status:"paid"}:x));
                        showT(`✓ ${u.custName} marked as FULLY PAID`);
                        setUdharPayId(null);setUdharPayAmt("");
                      }} style={{...sbtn,fontSize:9,padding:"3px 6px",background:C.a,color:"#fff",border:"none"}}>Full</button>
                      <button onClick={()=>{setUdharPayId(null);setUdharPayAmt("")}} style={{...sbtn,fontSize:9,padding:"3px 6px"}}>✕</button>
                    </div>
                  ):(
                    <div style={{display:"flex",gap:3}}>
                      {due>0&&<button onClick={()=>{setUdharPayId(u.id);setUdharPayAmt("")}} style={{...sbtn,fontSize:9,padding:"3px 8px",color:C.p,borderColor:"rgba(16,185,129,.3)"}}>💰 Pay</button>}
                      {due>0&&<a href={`https://wa.me/${(u.custPhone.replace(/[^0-9]/g,"").startsWith("0")?"92"+u.custPhone.replace(/[^0-9]/g,"").slice(1):u.custPhone.replace(/[^0-9]/g,""))}?text=${encodeURIComponent(`Assalam o Alaikum ${u.custName},\n\nYeh aapka udhar reminder hai ${receipt.businessName} se:\nTotal: Rs.${u.total}\nPaid: Rs.${u.paid}\nBaqi: Rs.${due}\nDate: ${u.date}\n\nBrahye karam jaldi payment kar dein. Shukriya!`)}`}
                        target="_blank" rel="noopener noreferrer" style={{...sbtn,fontSize:9,padding:"3px 6px",color:"#25D366",borderColor:"rgba(37,211,102,.3)",textDecoration:"none"}}>📱</a>}
                      {u.status==="paid"&&<span style={{fontSize:9,color:C.p,fontWeight:600}}>✓ Cleared</span>}
                      <button onClick={()=>{if(window.confirm(`Delete udhar record for ${u.custName}?`))setUdharLedger(prev=>prev.filter(x=>x.id!==u.id))}}
                        style={{...sbtn,fontSize:9,padding:"3px 6px",color:C.d,borderColor:"rgba(239,68,68,.3)"}}>🗑️</button>
                    </div>
                  )}
                </td>
              </tr>);})}</tbody>
          </table>
        </div>
        {/* Send reminders to all */}
        <div style={{marginTop:12,display:"flex",gap:8}}>
          <button onClick={()=>{
            const unpaid=udharLedger.filter(u=>u.total-u.paid>0);
            let delay=0;
            unpaid.forEach(u=>{
              const phone=u.custPhone.replace(/[^0-9]/g,"");const waPhone=phone.startsWith("0")?"92"+phone.slice(1):phone;
              const due=u.total-u.paid;
              setTimeout(()=>window.open(`https://wa.me/${waPhone}?text=${encodeURIComponent(`Assalam o Alaikum ${u.custName}, aapka Rs.${due} baqi hai ${receipt.businessName} se. Brahye karam payment kar dein.`)}`,"_blank"),delay);
              delay+=800;
            });
            showT(`✓ WhatsApp reminders sent to ${unpaid.length} customers`);
          }} style={{...sbtn,background:"#25D366",color:"#fff",border:"none",padding:"10px 18px",borderRadius:8}}>
            📱 Send WhatsApp reminder to all ({udharLedger.filter(u=>u.total-u.paid>0).length} customers)
          </button>
        </div>
      </div>
    )}

    {/* ===================== DISCOUNTS TAB ===================== */}
    {tab==="discounts"&&(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>🏷️ Discount Management</h2>
          <button onClick={()=>setShowAddDiscount(true)} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 14px"}}>+ Create Discount</button>
        </div>
        {showAddDiscount&&<Modal title="Create discount rule" onClose={()=>setShowAddDiscount(false)} wide>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            <div><label style={lbl}>Discount name *</label><input style={inp} value={newDisc.name} onChange={e=>setNewDisc(p=>({...p,name:e.target.value}))} placeholder="e.g. Summer Sale"/></div>
            <div><label style={lbl}>Apply to</label>
              <select style={inp} value={newDisc.type} onChange={e=>setNewDisc(p=>({...p,type:e.target.value,targetId:""}))}>
                <option value="product">Specific product</option><option value="category">Entire category</option>
              </select>
            </div>
            <div><label style={lbl}>{newDisc.type==="product"?"Select product":"Select category"}</label>
              <select style={inp} value={newDisc.targetId} onChange={e=>setNewDisc(p=>({...p,targetId:e.target.value}))}>
                <option value="">— Choose —</option>
                {newDisc.type==="product"?products.map(p=><option key={p.id} value={p.id}>{p.name}</option>):categories.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div><label style={lbl}>Discount % *</label><input style={inp} type="number" value={newDisc.percent} onChange={e=>setNewDisc(p=>({...p,percent:e.target.value}))} placeholder="e.g. 15"/></div>
            <div><label style={lbl}>Start date *</label><input style={inp} type="date" value={newDisc.startDate} onChange={e=>setNewDisc(p=>({...p,startDate:e.target.value}))}/></div>
            <div><label style={lbl}>End date *</label><input style={inp} type="date" value={newDisc.endDate} onChange={e=>setNewDisc(p=>({...p,endDate:e.target.value}))}/></div>
          </div>
          <button onClick={handleAddDisc} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px",marginTop:12}}>Create Discount</button>
        </Modal>}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,overflow:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{borderBottom:`2px solid ${C.b}`}}>
              {["Name","Type","Target","Discount","Start","End","Status","Action"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,textTransform:"uppercase",color:C.tm}}>{h}</th>
              ))}</tr></thead>
            <tbody>{discounts.map(d=>(
              <tr key={d.id} style={{borderBottom:`1px solid ${C.b}`}}>
                <td style={{padding:"8px 12px",fontWeight:600}}>{d.name}</td>
                <td style={{padding:"8px 12px"}}><span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:d.type==="category"?"rgba(139,92,246,.15)":"rgba(59,130,246,.15)",color:d.type==="category"?C.purple:C.a,fontWeight:600}}>{d.type}</span></td>
                <td style={{padding:"8px 12px",fontSize:12}}>{d.target}</td>
                <td style={{padding:"8px 12px",fontWeight:700,color:C.d}}>{d.percent}%</td>
                <td style={{padding:"8px 12px",fontSize:11,color:C.td}}>{d.startDate}</td>
                <td style={{padding:"8px 12px",fontSize:11,color:C.td}}>{d.endDate}</td>
                <td style={{padding:"8px 12px"}}>
                  <span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:4,background:d.active?"rgba(16,185,129,.15)":"rgba(100,116,139,.15)",color:d.active?C.p:C.tm}}>{d.active?"Active":"Inactive"}</span>
                </td>
                <td style={{padding:"8px 12px"}}>
                  <button onClick={()=>setDiscounts(p=>p.map(x=>x.id===d.id?{...x,active:!x.active}:x))} style={{...sbtn,fontSize:10}}>{d.active?"Deactivate":"Activate"}</button>
                </td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    )}

    {/* ===================== ANALYTICS TAB ===================== */}
    {tab==="analytics"&&(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>📊 Sales Analytics</h2>
          <div style={{display:"flex",gap:4}}>
            <select value={activeBranch} onChange={e=>setActiveBranch(+e.target.value)} style={{...inp,width:"auto",padding:"6px 10px",fontSize:11}}>
              <option value={0}>All branches</option>
              {branches.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
            {[{id:"day",l:"Today"},{id:"week",l:"This Week"},{id:"month",l:"This Month"}].map(p=>(
              <button key={p.id} onClick={()=>setAnalyticsPeriod(p.id)} style={{...sbtn,background:analyticsPeriod===p.id?C.a:"transparent",color:analyticsPeriod===p.id?"#fff":C.td,border:analyticsPeriod===p.id?"none":`1px solid ${C.b}`}}>{p.l}</button>
            ))}
          </div>
        </div>

        {/* KPI Cards */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
          {[{l:"Revenue",v:`Rs.${totalRev.toLocaleString()}`,c:C.p,icon:"💰"},{l:"Orders",v:totalOrders,c:C.a,icon:"🧾"},
            {l:"Items Sold",v:totalItems,c:C.w,icon:"📦"},{l:"Profit",v:`Rs.${totalProfit.toLocaleString()}`,c:C.purple,icon:"📈"}
          ].map((k,i)=>(
            <div key={i} style={{background:C.card,borderRadius:10,padding:14,border:`1px solid ${C.b}`,borderLeft:`3px solid ${k.c}`}}>
              <div style={{fontSize:10,color:C.tm,fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{k.icon} {k.l}</div>
              <div style={{fontSize:22,fontWeight:800,color:k.c}}>{k.v}</div>
              <div style={{fontSize:10,color:C.td}}>{analyticsPeriod==="day"?"Today":analyticsPeriod==="week"?"Last 7 days":"Last 30 days"}</div>
            </div>
          ))}
        </div>

        {/* Row 2: Revenue chart + Payment breakdown + Peak hours */}
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",gap:12,marginBottom:16}}>
          {/* Revenue chart */}
          <div style={{background:C.card,borderRadius:12,padding:16,border:`1px solid ${C.b}`}}>
            <h3 style={{margin:"0 0 12px",fontSize:14,fontWeight:700}}>Revenue trend</h3>
            <div style={{display:"flex",alignItems:"flex-end",gap:analyticsPeriod==="month"?3:8,height:160}}>
              {aData.map((d,i)=>(
                <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                  <div style={{fontSize:8,color:C.td}}>{(d.revenue/1000).toFixed(0)}k</div>
                  <div style={{width:"100%",borderRadius:"4px 4px 0 0",height:`${(d.revenue/maxRev)*140}px`,background:`linear-gradient(180deg,${C.p},${C.pd})`,minHeight:4}}/>
                  <div style={{fontSize:7,color:C.tm}}>{analyticsPeriod==="month"?d.date.slice(8):d.day}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Payment method breakdown */}
          <div style={{background:C.card,borderRadius:12,padding:16,border:`1px solid ${C.b}`}}>
            <h3 style={{margin:"0 0 12px",fontSize:14,fontWeight:700}}>💳 Payment methods</h3>
            {[{l:"Cash",pct:62,c:C.p,icon:"💵"},{l:"Card",pct:22,c:C.a,icon:"💳"},{l:"Mobile (JazzCash/EP)",pct:11,c:C.purple,icon:"📱"},{l:"Udhar (Credit)",pct:5,c:C.w,icon:"📒"}].map((m,i)=>(
              <div key={i} style={{marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}>
                  <span>{m.icon} {m.l}</span><span style={{fontWeight:700,color:m.c}}>{m.pct}%</span>
                </div>
                <div style={{height:6,background:C.s,borderRadius:3,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${m.pct}%`,background:m.c,borderRadius:3}}/>
                </div>
                <div style={{fontSize:9,color:C.tm}}>Rs.{Math.round(totalRev*m.pct/100).toLocaleString()}</div>
              </div>
            ))}
          </div>

          {/* Peak hours */}
          <div style={{background:C.card,borderRadius:12,padding:16,border:`1px solid ${C.b}`}}>
            <h3 style={{margin:"0 0 12px",fontSize:14,fontWeight:700}}>⏰ Peak hours</h3>
            {[{h:"9-11 AM",pct:15,orders:8},{h:"11-1 PM",pct:35,orders:22},{h:"1-3 PM",pct:55,orders:34},{h:"3-5 PM",pct:25,orders:16},{h:"5-7 PM",pct:80,orders:48},{h:"7-9 PM",pct:100,orders:62},{h:"9-11 PM",pct:45,orders:28}].map((t,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                <span style={{fontSize:10,color:C.td,width:52,flexShrink:0}}>{t.h}</span>
                <div style={{flex:1,height:8,background:C.s,borderRadius:4,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${t.pct}%`,borderRadius:4,background:t.pct>=70?C.d:t.pct>=40?C.w:C.p}}/>
                </div>
                <span style={{fontSize:9,color:C.tm,width:20}}>{t.orders}</span>
              </div>
            ))}
            <div style={{fontSize:9,color:C.tm,marginTop:6}}>🔴 Peak = 7-9 PM (Iftar/dinner rush)</div>
          </div>
        </div>

        {/* Row 3: Top products + Branch comparison */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
          <div style={{background:C.card,borderRadius:12,padding:16,border:`1px solid ${C.b}`}}>
            <h3 style={{margin:"0 0 12px",fontSize:14,fontWeight:700}}>Top products</h3>
            {products.slice(0,5).map((p,i)=>{const rev=Math.floor(p.price*(p.stock*0.3+Math.random()*50));return(
              <div key={p.id} style={{marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}>
                  <span style={{fontWeight:600}}>{i+1}. {p.img} {p.name}</span><span style={{color:C.p,fontWeight:700}}>Rs.{rev.toLocaleString()}</span>
                </div>
                <div style={{height:6,background:C.s,borderRadius:3,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${60+Math.random()*40}%`,background:`linear-gradient(90deg,${C.p},${C.a})`,borderRadius:3}}/>
                </div>
              </div>
            )})}
          </div>
          {/* Branch comparison */}
          <div style={{background:C.card,borderRadius:12,padding:16,border:`1px solid ${C.b}`}}>
            <h3 style={{margin:"0 0 12px",fontSize:14,fontWeight:700}}>🏢 Branch comparison</h3>
            {branches.map((b,i)=>{const rev=[890000,520000,340000][i]||0;const maxB=890000;return(
              <div key={b.id} style={{marginBottom:14}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}>
                  <span style={{fontWeight:600}}>{b.name}</span>
                  <span style={{fontWeight:700,color:C.p}}>Rs.{rev.toLocaleString()}</span>
                </div>
                <div style={{height:10,background:C.s,borderRadius:5,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${(rev/maxB)*100}%`,borderRadius:5,background:`linear-gradient(90deg,${[C.p,C.a,C.purple][i]},${[C.pd,C.a,C.purple][i]})`}}/>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:C.tm,marginTop:2}}>
                  <span>{[320,180,95][i]} orders</span><span>{[12,8,4][i]} employees</span><span>{[248,180,120][i]} products</span>
                </div>
              </div>
            )})}
          </div>
        </div>

        {/* Daily breakdown table */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,overflow:"auto"}}>
          <div style={{padding:"12px 14px",borderBottom:`1px solid ${C.b}`,fontWeight:700,fontSize:14}}>Daily breakdown</div>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{borderBottom:`2px solid ${C.b}`}}>
              {["Date","Day","Revenue","Orders","Items","Profit","Margin"].map(h=>(
                <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:10,fontWeight:700,textTransform:"uppercase",color:C.tm}}>{h}</th>
              ))}</tr></thead>
            <tbody>{aData.map((d,i)=>(
              <tr key={i} style={{borderBottom:`1px solid ${C.b}`}}>
                <td style={{padding:"7px 12px",fontSize:12}}>{d.date}</td>
                <td style={{padding:"7px 12px",fontSize:12,color:C.td}}>{d.day}</td>
                <td style={{padding:"7px 12px",fontWeight:700,color:C.p}}>Rs.{d.revenue.toLocaleString()}</td>
                <td style={{padding:"7px 12px"}}>{d.orders}</td>
                <td style={{padding:"7px 12px"}}>{d.items}</td>
                <td style={{padding:"7px 12px",fontWeight:600,color:C.purple}}>Rs.{d.profit.toLocaleString()}</td>
                <td style={{padding:"7px 12px",fontSize:11,color:d.profit/d.revenue>.3?C.p:C.w}}>{((d.profit/d.revenue)*100).toFixed(1)}%</td>
              </tr>
            ))}</tbody>
          </table>
        </div>

        {/* Data import section */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <h3 style={{margin:"0 0 12px",fontSize:15,fontWeight:700}}>📥 Import previous business data</h3>
          <div style={{fontSize:12,color:C.td,lineHeight:1.6,marginBottom:12}}>
            If your client has previous sales data from another POS system, Excel, or manual records, paste or upload it here. BillKaro will parse and import revenue history, inventory levels, customer records, and FBR invoice history.
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
            {[{l:"📊 Import sales history",d:"Upload CSV/Excel with date, items, total, payment method",f:"sales"},
              {l:"📦 Import inventory",d:"Upload product list with current stock levels and costs",f:"inventory"},
              {l:"🛡️ Import FBR records",d:"Upload previous FBR invoice data for continuity",f:"fbr"}].map(imp=>(
              <div key={imp.f} style={{background:C.s,borderRadius:10,padding:14,border:`1px solid ${C.b}`}}>
                <div style={{fontSize:13,fontWeight:700,marginBottom:4}}>{imp.l}</div>
                <div style={{fontSize:10,color:C.tm,marginBottom:8}}>{imp.d}</div>
                <label style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"6px 12px",cursor:"pointer",display:"inline-flex",alignItems:"center",gap:4,borderRadius:6}}>
                  📂 Upload file
                  <input type="file" accept=".csv,.xlsx,.xls,.json" style={{display:"none"}} onChange={()=>showT(`✓ ${imp.f} data imported successfully`)}/>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}

    {/* ===================== FBR TAB ===================== */}
    {tab==="fbr"&&(
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:700}}>🛡️ FBR Integration</h2>
          <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:13,fontWeight:700,color:sendToFbr?C.p:C.d}}>
            <span>FBR Reporting: {sendToFbr?"ON":"OFF"}</span>
            <div onClick={()=>setSendToFbr(!sendToFbr)} style={{width:40,height:22,borderRadius:11,background:sendToFbr?C.p:C.d,position:"relative",cursor:"pointer"}}>
              <div style={{width:18,height:18,borderRadius:9,background:"#fff",position:"absolute",top:2,left:sendToFbr?20:2,transition:"left .2s"}}/>
            </div>
          </label>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
          {[{l:"Synced",v:fbrLogs.filter(l=>l.status==="synced").length,c:C.p},{l:"Pending",v:fbrLogs.filter(l=>l.status==="pending").length,c:C.w},
            {l:"Failed",v:fbrLogs.filter(l=>l.status==="failed").length,c:C.d},{l:"Skipped (No FBR)",v:fbrLogs.filter(l=>l.status==="skipped").length,c:C.tm}
          ].map((s,i)=>(
            <div key={i} style={{background:C.card,borderRadius:10,padding:14,border:`1px solid ${C.b}`,borderLeft:`3px solid ${s.c}`}}>
              <div style={{fontSize:10,color:C.tm,fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{s.l}</div>
              <div style={{fontSize:26,fontWeight:800,color:s.c}}>{s.v}</div>
            </div>
          ))}
        </div>

        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,overflow:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{borderBottom:`2px solid ${C.b}`}}>
              {["Invoice","Time","Customer","Amount","FBR IRN","Status","Sent to FBR"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,textTransform:"uppercase",color:C.tm}}>{h}</th>
              ))}</tr></thead>
            <tbody>{fbrLogs.map(l=>(
              <tr key={l.id} style={{borderBottom:`1px solid ${C.b}`}}>
                <td style={{padding:"8px 12px",fontFamily:"monospace",fontSize:11,fontWeight:600}}>{l.id}</td>
                <td style={{padding:"8px 12px",fontSize:11,color:C.td}}>{l.time}</td>
                <td style={{padding:"8px 12px",fontSize:11}}>{l.customer}</td>
                <td style={{padding:"8px 12px",fontWeight:700,color:C.p}}>Rs.{l.total.toLocaleString()}</td>
                <td style={{padding:"8px 12px",fontSize:10,fontFamily:"monospace",color:l.irn==="N/A"||l.irn==="—"?C.tm:C.td}}>{l.irn}</td>
                <td style={{padding:"8px 12px"}}><span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:4,
                  background:l.status==="synced"?"rgba(16,185,129,.15)":l.status==="pending"?"rgba(245,158,11,.15)":l.status==="skipped"?"rgba(100,116,139,.15)":"rgba(239,68,68,.15)",
                  color:l.status==="synced"?C.p:l.status==="pending"?C.w:l.status==="skipped"?C.tm:C.d
                }}>{l.status==="synced"?"✓ Synced":l.status==="pending"?"⏳ Pending":l.status==="skipped"?"⊘ Skipped":"✗ Failed"}</span></td>
                <td style={{padding:"8px 12px"}}><span style={{fontSize:10,fontWeight:600,color:l.sentToFbr?C.p:C.tm}}>{l.sentToFbr?"Yes":"No"}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </div>

        {/* FBR Setup Guide */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <h3 style={{margin:0,fontSize:15,fontWeight:700}}>📋 How to set up FBR integration</h3>
            <button onClick={()=>setShowFbrSetup(!showFbrSetup)} style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"6px 14px"}}>{showFbrSetup?"Hide guide":"Show setup guide"}</button>
          </div>
          {showFbrSetup&&(
            <div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
                {[
                  {step:"1",title:"Register on IRIS portal",desc:"Log into e.fbr.gov.pk with your NTN credentials. Go to Registration → POS Client Registration. Fill in business name, address, and NTN details.",link:"https://e.fbr.gov.pk",linkText:"Open IRIS Portal"},
                  {step:"2",title:"Get POS registration number",desc:"After registration, FBR generates a unique POS registration number. This number will be used in every invoice sent to FBR.",link:"",linkText:""},
                  {step:"3",title:"Generate API credentials",desc:"From your IRIS dashboard, generate a Security Token (Bearer token). This token is valid for 5 years. Also get your API endpoint URL from FBR.",link:"https://gw.fbr.gov.pk",linkText:"FBR API Gateway"},
                  {step:"4",title:"Enter credentials in BillKaro",desc:"Go to the settings below and enter your POS Registration ID, NTN, and Security Token. BillKaro connects to FBR automatically.",link:"",linkText:""},
                  {step:"5",title:"Test in sandbox",desc:"Run 5-10 test invoices in sandbox mode. FBR provides a test endpoint to validate your setup before going live.",link:"https://gw-sandbox.fbr.gov.pk",linkText:"FBR Sandbox"},
                  {step:"6",title:"Go live",desc:"Once tests pass, switch to production endpoint. All invoices are now reported to FBR in real-time. FBR IRN and QR code appear on every receipt.",link:"",linkText:""},
                ].map(s=>(
                  <div key={s.step} style={{background:C.s,borderRadius:10,padding:14,borderTop:`3px solid ${C.a}`}}>
                    <div style={{fontSize:20,fontWeight:800,color:C.a,marginBottom:4}}>{s.step}</div>
                    <div style={{fontSize:13,fontWeight:700,marginBottom:4}}>{s.title}</div>
                    <div style={{fontSize:11,color:C.td,lineHeight:1.5}}>{s.desc}</div>
                    {s.link&&<a href={s.link} target="_blank" rel="noopener noreferrer" style={{fontSize:11,color:C.a,marginTop:6,display:"inline-block"}}>{s.linkText} ↗</a>}
                  </div>
                ))}
              </div>

              {/* FBR credentials form */}
              <div style={{background:C.s,borderRadius:10,padding:16,border:`1px solid ${C.b}`}}>
                <h4 style={{margin:"0 0 12px",fontSize:14,fontWeight:700,color:C.w}}>🔑 FBR connection settings</h4>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
                  <div><label style={lbl}>POS registration ID</label><input style={inp} value={fbrConfig.posId} onChange={e=>setFbrConfig(p=>({...p,posId:e.target.value}))} placeholder="POS-XXX-0001"/></div>
                  <div><label style={lbl}>NTN number</label><input style={inp} value={fbrConfig.ntn} onChange={e=>setFbrConfig(p=>({...p,ntn:e.target.value}))} placeholder="1234567-8"/></div>
                  <div><label style={lbl}>Security token (Bearer)</label><input style={inp} type="password" value={fbrConfig.token} onChange={e=>setFbrConfig(p=>({...p,token:e.target.value}))} placeholder="fbr_tk_..."/></div>
                  <div><label style={lbl}>API endpoint</label><input style={inp} value={fbrConfig.endpoint} onChange={e=>setFbrConfig(p=>({...p,endpoint:e.target.value}))}/></div>
                  <div><label style={lbl}>Token expiry date</label><input style={inp} type="date" value={fbrConfig.tokenExpiry} onChange={e=>setFbrConfig(p=>({...p,tokenExpiry:e.target.value}))}/></div>
                  <div><label style={lbl}>Auto-retry failed</label>
                    <select style={inp} value={fbrConfig.autoRetry?"yes":"no"} onChange={e=>setFbrConfig(p=>({...p,autoRetry:e.target.value==="yes"}))}>
                      <option value="yes">Yes — retry 3x automatically</option><option value="no">No — manual retry only</option>
                    </select>
                  </div>
                </div>
                <div style={{display:"flex",gap:8,marginTop:12}}>
                  <button onClick={()=>showT("✓ FBR settings saved")} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px"}}>Save FBR Settings</button>
                  <button onClick={()=>showT("✓ Test invoice sent to FBR sandbox — response OK")} style={{...sbtn,background:C.w,color:"#000",border:"none",padding:"8px 16px"}}>🧪 Send test invoice</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )}
    {tab==="settings"&&(
      <div>
        <h2 style={{margin:"0 0 16px",fontSize:18,fontWeight:700}}>⚙️ Settings</h2>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          {/* Receipt customization */}
          <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20}}>
            <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:700,color:C.p}}>🧾 Receipt / Print settings</h3>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div style={{gridColumn:"1/-1"}}><label style={lbl}>Business name (appears on receipt)</label><input style={{...inp,fontSize:15,fontWeight:700}} value={receipt.businessName} onChange={e=>setReceipt(p=>({...p,businessName:e.target.value}))}/></div>
              <div style={{gridColumn:"1/-1"}}>
                <label style={lbl}>Logo — text or image</label>
                <div style={{display:"flex",gap:10,alignItems:"center"}}>
                  <div style={{display:"flex",gap:6,flex:1}}>
                    <label style={{display:"flex",alignItems:"center",gap:4,fontSize:12,cursor:"pointer"}}>
                      <input type="radio" name="logoType" checked={receipt.logoType!=="image"} onChange={()=>setReceipt(p=>({...p,logoType:"text"}))} style={{accentColor:C.p}}/>Text
                    </label>
                    <label style={{display:"flex",alignItems:"center",gap:4,fontSize:12,cursor:"pointer"}}>
                      <input type="radio" name="logoType" checked={receipt.logoType==="image"} onChange={()=>setReceipt(p=>({...p,logoType:"image"}))} style={{accentColor:C.p}}/>Image
                    </label>
                  </div>
                </div>
                {receipt.logoType==="image"?(
                  <div style={{marginTop:8}}>
                    <label style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"8px 16px",cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6,borderRadius:8}}>
                      📷 Upload logo image
                      <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                        const file=e.target.files[0];if(!file) return;
                        const reader=new FileReader();
                        reader.onload=ev=>setReceipt(p=>({...p,logoImage:ev.target.result}));
                        reader.readAsDataURL(file);showT("✓ Logo image uploaded");
                      }}/>
                    </label>
                    {receipt.logoImage&&<div style={{marginTop:8,display:"flex",alignItems:"center",gap:10}}>
                      <img src={receipt.logoImage} alt="Logo" style={{maxHeight:50,maxWidth:120,borderRadius:6,border:`1px solid ${C.b}`}}/>
                      <button onClick={()=>setReceipt(p=>({...p,logoImage:""}))} style={{...sbtn,fontSize:10,color:C.d}}>Remove</button>
                    </div>}
                    <div style={{fontSize:10,color:C.tm,marginTop:4}}>Recommended: PNG or JPG, max 200×200px, transparent background</div>
                  </div>
                ):(
                  <div style={{marginTop:8}}>
                    <input style={{...inp,fontSize:16,fontWeight:700,letterSpacing:1}} value={receipt.logoText} onChange={e=>setReceipt(p=>({...p,logoText:e.target.value}))} placeholder="e.g. SAKOON MART or SM"/>
                    <div style={{fontSize:10,color:C.tm,marginTop:4}}>Type any text — short or long. Logo auto-sizes to fit on the receipt.</div>
                  </div>
                )}
              </div>
              <div><label style={lbl}>Phone number</label><input style={inp} value={receipt.phone} onChange={e=>setReceipt(p=>({...p,phone:e.target.value}))}/></div>
              <div><label style={lbl}>Email address</label><input style={inp} value={receipt.email} onChange={e=>setReceipt(p=>({...p,email:e.target.value}))}/></div>
              <div style={{gridColumn:"1/-1"}}><label style={lbl}>Business address</label><input style={inp} value={receipt.address} onChange={e=>setReceipt(p=>({...p,address:e.target.value}))}/></div>
              <div style={{gridColumn:"1/-1"}}><label style={lbl}>Thank you message / tagline</label><input style={inp} value={receipt.tagline} onChange={e=>setReceipt(p=>({...p,tagline:e.target.value}))}/></div>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:10,marginTop:14}}>
              {[{k:"showLogo",l:"Show logo"},{k:"showPhone",l:"Show phone"},{k:"showEmail",l:"Show email"},{k:"showAddress",l:"Show address"},{k:"showFbrQr",l:"FBR QR code"}].map(t=>(
                <label key={t.k} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12}}>
                  <input type="checkbox" checked={receipt[t.k]} onChange={e=>setReceipt(p=>({...p,[t.k]:e.target.checked}))} style={{accentColor:C.p}}/>{t.l}
                </label>
              ))}
            </div>
            <button onClick={()=>showT("✓ Receipt settings saved")} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px",marginTop:14}}>Save Settings</button>
          </div>

          {/* Receipt preview */}
          <div style={{background:"#fff",borderRadius:12,padding:20,color:"#000",fontFamily:"monospace",fontSize:11,lineHeight:1.6}}>
            <div style={{textAlign:"center",borderBottom:"1px dashed #ccc",paddingBottom:10,marginBottom:8}}>
              {receipt.showLogo&&(
                receipt.logoType==="image"&&receipt.logoImage?
                  <img src={receipt.logoImage} alt="Logo" style={{maxHeight:60,maxWidth:160,marginBottom:6,display:"block",margin:"0 auto 6px"}}/>
                : <div style={{
                    display:"inline-block",padding:receipt.logoText.length>6?"6px 14px":"8px 12px",
                    borderRadius:8,background:"#000",color:"#fff",fontWeight:800,marginBottom:6,
                    fontSize:receipt.logoText.length>10?12:receipt.logoText.length>6?14:18,
                    letterSpacing:receipt.logoText.length>6?0.5:1,maxWidth:"90%",wordBreak:"break-word"
                  }}>{receipt.logoText}</div>
              )}
              <div style={{fontWeight:700,fontSize:14}}>{receipt.businessName}</div>
              {receipt.showAddress&&<div style={{fontSize:10,color:"#666"}}>{receipt.address}</div>}
              {receipt.showPhone&&<div style={{fontSize:10,color:"#666"}}>Tel: {receipt.phone}</div>}
              {receipt.showEmail&&<div style={{fontSize:10,color:"#666"}}>{receipt.email}</div>}
            </div>
            <div style={{fontSize:10,color:"#666",marginBottom:4}}>Date: {new Date().toLocaleDateString()} | INV-001</div>
            {selectedCustomer&&<div style={{fontSize:10,color:"#333",marginBottom:4,borderBottom:"1px dashed #eee",paddingBottom:4}}>Customer: {selectedCustomer.name} | {selectedCustomer.phone}</div>}
            <div style={{borderBottom:"1px dashed #ccc",paddingBottom:4,marginBottom:4}}>
              <div style={{display:"flex",justifyContent:"space-between"}}><span>Tapal Danedar 400g x2</span><span>Rs.1,300</span></div>
              <div style={{display:"flex",justifyContent:"space-between"}}><span>Nestle Milk 1L x1</span><span>Rs.280</span></div>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:10}}><span>Subtotal:</span><span>Rs.1,580</span></div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:10}}><span>GST (17%):</span><span>Rs.269</span></div>
            <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:13,borderTop:"1px solid #000",paddingTop:4,marginTop:4}}><span>TOTAL:</span><span>Rs.1,849</span></div>
            {receipt.showFbrQr&&<div style={{textAlign:"center",marginTop:8}}><div style={{width:50,height:50,border:"2px solid #000",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:8}}>FBR QR</div><div style={{fontSize:8,color:"#666"}}>Verify via FBR Tax Asaan App</div></div>}
            <div style={{textAlign:"center",marginTop:8,fontSize:10,color:"#666"}}>{receipt.tagline}</div>
          </div>
        </div>

        {/* GST Rules management */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <h3 style={{margin:0,fontSize:15,fontWeight:700}}>Tax / GST rules</h3>
            <button onClick={()=>setShowAddGst(true)} style={{...sbtn,background:C.w,color:"#000",border:"none"}}>+ Add Rule</button>
          </div>
          <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
            {gstRules.map(g=>(
              <div key={g.id} style={{background:C.s,borderRadius:8,padding:"10px 16px",border:`1px solid ${C.b}`,minWidth:120}}>
                <div style={{fontWeight:700,fontSize:13,color:C.w}}>{g.rate}%</div>
                <div style={{fontSize:11,color:C.td}}>{g.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Categories management */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <h3 style={{margin:0,fontSize:15,fontWeight:700}}>Product categories</h3>
            <button onClick={()=>setShowAddCat(true)} style={{...sbtn,background:C.purple,color:"#fff",border:"none"}}>+ Add Category</button>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {categories.map(c=>(
              <span key={c} style={{padding:"6px 14px",borderRadius:6,background:"rgba(59,130,246,.1)",color:C.a,fontSize:12,fontWeight:600}}>{c}</span>
            ))}
          </div>
        </div>

        {/* Employee PIN Management */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:700}}>🔐 Employee PINs & Access</h3>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:12}}>
            {employees.map(emp=>(
              <div key={emp.id} style={{background:C.s,borderRadius:10,padding:14,border:`1px solid ${C.b}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                  <span style={{fontWeight:700,fontSize:13}}>{emp.name}</span>
                  <span style={{fontSize:10,padding:"2px 8px",borderRadius:4,
                    background:emp.role==="owner"?"rgba(245,158,11,.15)":emp.role==="manager"?"rgba(139,92,246,.15)":"rgba(59,130,246,.15)",
                    color:emp.role==="owner"?C.w:emp.role==="manager"?C.purple:C.a,fontWeight:600}}>{emp.role}</span>
                </div>
                <div style={{fontSize:11,color:C.td,marginBottom:8}}>Current PIN: ****</div>
                <div style={{display:"flex",gap:6}}>
                  <input id={`pin-${emp.id}`} type="password" maxLength={4} placeholder="New PIN" style={{...inp,flex:1,padding:"6px 8px",fontSize:12}}/>
                  <button onClick={()=>{
                    const el=document.getElementById(`pin-${emp.id}`);
                    if(!el||el.value.length!==4) return showT("PIN must be 4 digits");
                    emp.pin=el.value;el.value="";
                    showT(`✓ PIN updated for ${emp.name}`);
                  }} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"6px 10px",fontSize:10}}>Update</button>
                </div>
              </div>
            ))}
          </div>
          <div style={{fontSize:10,color:C.tm,marginTop:10}}>Only admin/owner can change PINs. Each employee uses their PIN to login and open their shift.</div>
        </div>

        {/* Barcode Auto-Fetch Settings */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:700}}>📡 Barcode auto-fetch</h3>
          <div style={{fontSize:12,color:C.td,lineHeight:1.6,marginBottom:12}}>
            When a barcode is scanned and not found in your inventory, BillKaro can automatically look up the product from online databases and pre-fill the name and details.
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
            <button onClick={()=>showT("✓ Open Food Facts enabled — Pakistani products will auto-fetch")} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 14px",borderRadius:8}}>
              ✓ Enable Open Food Facts (free)
            </button>
            <button onClick={()=>showT("✓ UPC Database enabled")} style={{...sbtn,padding:"8px 14px",borderRadius:8}}>
              Enable UPC Database
            </button>
          </div>
          <div style={{fontSize:11,color:C.tm}}>Auto-fetch uses free global barcode databases. For Pakistani-specific products, products are learned from your own inventory over time.</div>
        </div>

        {/* Multi-branch settings */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <h3 style={{margin:0,fontSize:15,fontWeight:700}}>🏢 Multi-branch</h3>
            <label onClick={()=>setMultiBranch(!multiBranch)} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,fontWeight:600,color:multiBranch?C.p:C.tm}}>
              {multiBranch?"ON":"OFF"}
              <div style={{width:36,height:20,borderRadius:10,background:multiBranch?C.p:C.b,position:"relative"}}>
                <div style={{width:16,height:16,borderRadius:8,background:"#fff",position:"absolute",top:2,left:multiBranch?18:2,transition:"left .2s"}}/>
              </div>
            </label>
          </div>
          {!multiBranch?<div style={{fontSize:12,color:C.td}}>Multi-branch is OFF — single store mode. Turn ON if client has multiple locations.</div>
          :<>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(210px,1fr))",gap:10}}>
            {branches.map(b=>(
              <div key={b.id} style={{background:activeBranch===b.id?"rgba(16,185,129,.08)":C.s,borderRadius:10,padding:12,border:`1px solid ${activeBranch===b.id?C.p:C.b}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <span style={{fontWeight:700,fontSize:12,color:activeBranch===b.id?C.p:C.t}}>{b.name}</span>
                  <div style={{display:"flex",gap:3}}>
                    <button onClick={()=>setActiveBranch(b.id)} style={{...sbtn,fontSize:8,padding:"2px 5px",background:activeBranch===b.id?C.p:"transparent",color:activeBranch===b.id?"#fff":C.td,border:activeBranch===b.id?"none":`1px solid ${C.b}`}}>{activeBranch===b.id?"✓":"Use"}</button>
                    {branches.length>1&&<button onClick={()=>{setBranches(p=>p.filter(x=>x.id!==b.id));if(activeBranch===b.id&&branches.length>1)setActiveBranch(branches[0].id)}}
                      style={{...sbtn,fontSize:8,padding:"2px 5px",color:C.d,borderColor:"rgba(239,68,68,.3)"}}>✕</button>}
                  </div>
                </div>
                <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                  {[{k:"inv",l:"Inventory"},{k:"fbr",l:"FBR"},{k:"udhar",l:"Udhar"}].map(f=>(
                    <label key={f.k} style={{display:"flex",alignItems:"center",gap:2,fontSize:9,cursor:"pointer",color:C.td}}>
                      <input type="checkbox" checked={b[f.k]!==false} onChange={()=>setBranches(p=>p.map(x=>x.id===b.id?{...x,[f.k]:!x[f.k]}:x))} style={{accentColor:C.p,width:12,height:12}}/>{f.l}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <button onClick={()=>{const n=prompt("Branch name (e.g. Branch 2 — Faisalabad):");if(n)setBranches(p=>[...p,{id:Date.now(),name:n,inv:true,fbr:true,udhar:true}])}}
            style={{...sbtn,background:C.a,color:"#fff",border:"none",padding:"8px 14px",marginTop:10}}>+ Add branch</button>
          <div style={{fontSize:10,color:C.tm,marginTop:6}}>Add up to 50 branches. Each has own inventory, FBR, and Udhar. Toggle features per branch.</div>
          </>}
        </div>

        {/* License management */}
        <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.b}`,padding:20,marginTop:16}}>
          <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:700}}>🔑 License & protection</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
            <div><label style={lbl}>License key</label><input style={inp} value={licenseKey} onChange={e=>setLicenseKey(e.target.value)} placeholder="BK-XXXX-XXXX-XXXX"/></div>
            <div><label style={lbl}>Status</label>
              <div style={{...inp,display:"flex",alignItems:"center",gap:8}}>
                <span style={{width:8,height:8,borderRadius:"50%",background:licenseValid?C.p:C.d}}/>
                <span style={{color:licenseValid?C.p:C.d,fontWeight:600}}>{licenseValid?"✓ Active — Demo License":"✗ Invalid or expired"}</span>
              </div>
            </div>
          </div>
          <div style={{background:C.s,borderRadius:8,padding:14,fontSize:11,color:C.td,lineHeight:1.6}}>
            <b style={{color:C.w}}>How licensing works in production:</b><br/>
            Each client purchase generates a unique license key tied to their NTN number and device. The key is validated against your license server on first launch and checked weekly. Without a valid key, the app shows only a demo mode. This prevents copying.<br/><br/>
            <b>License tiers:</b> Starter (1 terminal) · Growth (3 terminals) · Business (10 terminals) · Enterprise (unlimited)<br/>
            <b>Protection:</b> Code obfuscation + license server validation + device fingerprinting
          </div>
          <button onClick={()=>showT("✓ License verified — active until Dec 2026")} style={{...sbtn,background:C.p,color:"#fff",border:"none",padding:"8px 16px",marginTop:12}}>Verify License</button>
        </div>
      </div>
    )}

    </div>
    <style>{`input::placeholder{color:${C.tm}} select{appearance:auto} textarea::placeholder{color:${C.tm}} *::-webkit-scrollbar{width:4px} *::-webkit-scrollbar-track{background:transparent} *::-webkit-scrollbar-thumb{background:${C.b};border-radius:2px}`}</style>
    </>}
  </div>);
}

// ===== REUSABLE COMPONENTS =====
function Modal({title,onClose,children,wide}){
  return(
    <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.p}`,padding:20,marginBottom:16}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}>
        <h3 style={{margin:0,fontSize:15,fontWeight:700,color:C.p}}>{title}</h3>
        <button onClick={onClose} style={{background:"none",border:"none",color:C.tm,cursor:"pointer",fontSize:16}}>✕</button>
      </div>
      {children}
    </div>
  );
}

function Row({l,v,c}){
  return <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:c||C.td,marginBottom:3}}><span>{l}</span><span style={{fontWeight:600}}>{v}</span></div>;
}
